// Generated by Avo VERSION 174.22.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "2GQRkd2H3Rnk4FV16NaK";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "r6lpK6ex7dNhv2Df1kTo",
          "br": "4MiS4rkehbuVZbFeC26sf",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "5PhajbVijwhXVKIJtGMT",
          "se": (new Date()).toISOString(),
          "so": "OXY1Uf7nb",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "r6lpK6ex7dNhv2Df1kTo",
          "br": "4MiS4rkehbuVZbFeC26sf",
          "en": env,
          "ty": type,
          "sc": "5PhajbVijwhXVKIJtGMT",
          "se": (new Date()).toISOString(),
          "so": "OXY1Uf7nb",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "5PhajbVijwhXVKIJtGMT",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface PupilExitQuiz {
  questionResult: QuestionResultValueType
  questionType: string
  hintOffered: boolean
  hintAccessed: boolean
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType
  questionNumber: number
}

export interface TeacherSchoolManualEntryDetails {
  schoolNameText: string
  schoolAddressText: string
}

export interface PupilStarterQuiz {
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType
  questionType: string
  questionResult: QuestionResultValueType
  hintOffered: boolean
  hintAccessed: boolean
  questionNumber: number
}

export interface ActiveFilters {
}

export const SingleSignOnService = {
  'EMAIL': 'Email',
  'GOOGLE': 'Google',
  'MICROSOFT': 'Microsoft',
} as const;
export type SingleSignOnServiceType = typeof SingleSignOnService;
export type SingleSignOnServiceValueType = SingleSignOnServiceType[keyof SingleSignOnServiceType];

export const FilterModificationType = {
  'ADD': 'add',
  'REMOVE': 'remove',
} as const;
export type FilterModificationTypeType = typeof FilterModificationType;
export type FilterModificationTypeValueType = FilterModificationTypeType[keyof FilterModificationTypeType];

export const LessonReleaseCohort = {
  '2020_2023': '2020-2023',
  '2023_2026': '2023-2026',
} as const;
export type LessonReleaseCohortType = typeof LessonReleaseCohort;
export type LessonReleaseCohortValueType = LessonReleaseCohortType[keyof LessonReleaseCohortType];

export const EventVersion = {
  '2_0_0': '2.0.0',
} as const;
export type EventVersionType = typeof EventVersion;
export type EventVersionValueType = EventVersionType[keyof EventVersionType];

export const ResourceTypes = {
  'STARTER_QUIZ': 'starter-quiz',
  'EXIT_QUIZ': 'exit-quiz',
  'WORKSHEET': 'worksheet',
  'VIDEO': 'video',
} as const;
export type ResourceTypesType = typeof ResourceTypes;
export type ResourceTypesValueType = ResourceTypesType[keyof ResourceTypesType];

export const VideoLocation = {
  'WEBINAR': 'webinar',
  'MARKETING': 'marketing',
  'LESSON': 'lesson',
  'BLOG': 'blog',
  'PUPIL': 'pupil',
  'MEDIA_CLIPS': 'media clips',
} as const;
export type VideoLocationType = typeof VideoLocation;
export type VideoLocationValueType = VideoLocationType[keyof VideoLocationType];

export const UserAccountVerificationStatus = {
  'AWAITING_VERIFICATION': 'awaiting-verification',
  'DELETED': 'deleted',
  'DISABLED': 'disabled',
  'VERIFIED': 'verified',
} as const;
export type UserAccountVerificationStatusType = typeof UserAccountVerificationStatus;
export type UserAccountVerificationStatusValueType = UserAccountVerificationStatusType[keyof UserAccountVerificationStatusType];

export const ExamBoard = {
  'AQA': 'AQA',
  'EDEXCEL': 'Edexcel',
  'EDUQAS': 'Eduqas',
  'OCR': 'OCR',
  'WJEC': 'WJEC',
  'EDEXCEL_B': 'Edexcel B',
} as const;
export type ExamBoardType = typeof ExamBoard;
export type ExamBoardValueType = ExamBoardType[keyof ExamBoardType];

export const Context = {
  'HOMEPAGE': 'homepage',
  'SEARCH': 'search',
} as const;
export type ContextType = typeof Context;
export type ContextValueType = ContextType[keyof ContextType];

export const ComponentType = {
  'HAMBURGER_MENU_BUTTON': 'hamburger_menu_button',
  'TEXT_INPUT': 'text_input',
  'REGENERATE_RESPONSE_BUTTON': 'regenerate_response_button',
  'SELECT_OAK_LESSON': 'select_oak_lesson',
  'TYPE_EDIT': 'type_edit',
  'LESSON_FINISH_CHECK': 'lesson_finish_check',
  'CONTINUE_BUTTON': 'continue_button',
  'CONTINUE_TEXT': 'continue_text',
  'GO_TO_SHARE_PAGE_BUTTON': 'go_to_share_page_button',
  'EXAMPLE_LESSON_BUTTON': 'example_lesson_button',
  'HOMEPAGE_PRIMARY_CREATE_A_LESSON_BUTTON': 'homepage_primary_create_a_lesson_button',
  'HOMEPAGE_SECONDARY_CREATE_A_LESSON_BUTTON': 'homepage_secondary_create_a_lesson_button',
  'FOOTER_MENU_LINK': 'footer_menu_link',
  'FILTER_LINK': 'filter_link',
  'KEYSTAGE_KEYPAD_BUTTON': 'keystage_keypad_button',
  'LESSON_CARD': 'lesson_card',
  'LESSON_DOWNLOAD_BUTTON': 'lesson_download_button',
  'PROGRAMME_CARD': 'programme_card',
  'SEARCH_BUTTON': 'search_button',
  'SEARCH_RESULT_ITEM': 'search_result_item',
  'SHARE_BUTTON': 'share_button',
  'SUBJECT_CARD': 'subject_card',
  'UNIT_CARD': 'unit_card',
  'SIGNUP_FORM': 'signup_form',
  'SKIP_BUTTON': 'skip_button',
  'PAGE_VIEW': 'page view',
  'YEAR_KEYPAD_BUTTON': 'year_keypad_button',
  'UNIT_DOWNLOAD_BUTTON': 'unit_download_button',
  'SEARCH_GET_STARTED_BUTTON': 'search_get_started_button',
  'AIMS_AND_PURPOSE': 'aims_and_purpose',
  'CURICULUM_COHERENCE': 'curiculum_coherence',
  'CURRICULUM_DELIVERY': 'curriculum_delivery',
  'CURRICULUM_VISUALISER_BUTTON': 'curriculum_visualiser_button',
  'DOWNLOAD_BUTTON': 'download_button',
  'DOWNLOAD_TAB': 'download_tab',
  'EXPLAINER_TAB': 'explainer_tab',
  'FOLLOWING_UNIT_DESC': 'following_unit_desc',
  'HOMEPAGE_BUTTON': 'homepage_button',
  'HOMEPAGE_TAB': 'homepage_tab',
  'LANDING_PAGE_BUTTON': 'landing_page_button',
  'LEARNING_TIER_BUTTON': 'learning_tier_button',
  'LESSONS_IN_UNIT': 'lessons_in_unit',
  'NATIONAL_CURRICULUM': 'national_curriculum',
  'OAK_CURRICULUM_PRINCIPLES': 'oak_curriculum_principles',
  'OAK_SUBJECT_PRINCIPLES': 'oak_subject_principles',
  'OUR_CURRICULUM_PARTNER': 'our_curriculum_partner',
  'PREVIOUS_UNIT_DESC': 'previous_unit_desc',
  'RECOMMENDATIONS_FROM_SUBJECT_SPECIFIC_REPORTS': 'recommendations_from_subject_specific_reports',
  'SEE_LESSONS_IN_UNIT_BUTTON': 'see_lessons_in_unit_button',
  'SUBJECT_CATEGORY_BUTTON': 'subject_category_button',
  'SUBJECT_SPECIFIC_NEEDS': 'subject_specific_needs',
  'UNIT_INFO_BUTTON': 'unit_info_button',
  'UNIT_SEQUENCE_TAB': 'unit_sequence_tab',
  'VIDEO': 'video',
  'WHY_THIS_WHY_NOW': 'why_this_why_now',
  'YEAR_GROUP_BUTTON': 'year_group_button',
  'ADD_ADDITIONAL_MATERIALS_BUTTON': 'add_additional_materials_button',
  'MODIFY_BUTTON': 'modify_button',
  'EXAM_SUBJECT_BUTTON': 'exam_subject_button',
  'GO_TO_MEDIA_CLIPS_PAGE_BUTTON': 'go_to_media_clips_page_button',
  'MEDIA_CLIPS_PLAYED': 'media_clips_played',
} as const;
export type ComponentTypeType = typeof ComponentType;
export type ComponentTypeValueType = ComponentTypeType[keyof ComponentTypeType];

export const MediaClipsButtonName = {
  'PLAY_ALL': 'play all',
  'SELECT_CLIP': 'select clip',
} as const;
export type MediaClipsButtonNameType = typeof MediaClipsButtonName;
export type MediaClipsButtonNameValueType = MediaClipsButtonNameType[keyof MediaClipsButtonNameType];

export const OnwardIntent = {
  'VIEW_UNIT': 'view-unit',
  'VIEW_LESSON': 'view-lesson',
  'DOWNLOAD_LESSON_RESOURCES': 'download-lesson-resources',
} as const;
export type OnwardIntentType = typeof OnwardIntent;
export type OnwardIntentValueType = OnwardIntentType[keyof OnwardIntentType];

export const SchoolOption = {
  'HOMESCHOOL': 'Homeschool',
  'NOT_LISTED': 'Not listed',
  'SELECTED_SCHOOL': 'Selected school',
} as const;
export type SchoolOptionType = typeof SchoolOption;
export type SchoolOptionValueType = SchoolOptionType[keyof SchoolOptionType];

export const AnalyticsUseCase = {
  'PUPIL': 'Pupil',
  'TEACHER': 'Teacher',
} as const;
export type AnalyticsUseCaseType = typeof AnalyticsUseCase;
export type AnalyticsUseCaseValueType = AnalyticsUseCaseType[keyof AnalyticsUseCaseType];

export const QuestionResult = {
  'CORRECT': 'correct',
  'INCORRECT': 'incorrect',
} as const;
export type QuestionResultType = typeof QuestionResult;
export type QuestionResultValueType = QuestionResultType[keyof QuestionResultType];

export const DownloadResourceButtonName = {
  'ALL': 'all',
  'WORKSHEET': 'worksheet',
  'STARTER_QUIZ': 'starter quiz',
  'EXIT_QUIZ': 'exit quiz',
  'SLIDE_DECK': 'slide deck',
  'ADDITIONAL_MATERIAL': 'additional material',
  'LESSON_FILES': 'lesson files',
  'LESSON_GUIDE': 'lesson guide',
} as const;
export type DownloadResourceButtonNameType = typeof DownloadResourceButtonName;
export type DownloadResourceButtonNameValueType = DownloadResourceButtonNameType[keyof DownloadResourceButtonNameType];

export const ResourceType = {
  'SLIDE_DECK': 'slide deck',
  'STARTER_QUIZ_QUESTIONS': 'starter quiz questions',
  'STARTER_QUIZ_ANSWERS': 'starter quiz answers',
  'EXIT_QUIZ_QUESTIONS': 'exit quiz questions',
  'EXIT_QUIZ_ANSWERS': 'exit quiz answers',
  'WORKSHEET_PDF': 'worksheet pdf',
  'WORKSHEET_PPTX': 'worksheet pptx',
  'ADDITIONAL_MATERIALS': 'additional materials',
  'CURRICULUM_DOCUMENT': 'curriculum document',
  'CURRICULUM_PLAN': 'curriculum plan',
  'PREVIOUSLY_RELEASED_CURRICULUM_PLAN': 'previously released curriculum plan',
  'LESSON_GUIDE': 'lesson guide',
  'LESSON_FILES': 'lesson files',
} as const;
export type ResourceTypeType = typeof ResourceType;
export type ResourceTypeValueType = ResourceTypeType[keyof ResourceTypeType];

export const TierName = {
  'CORE': 'Core',
  'FOUNDATION': 'Foundation',
  'HIGHER': 'Higher',
} as const;
export type TierNameType = typeof TierName;
export type TierNameValueType = TierNameType[keyof TierNameType];

export const Product = {
  'AI_LESSON_ASSISTANT': 'ai lesson assistant',
  'CURRICULUM_RESOURCES': 'curriculum resources',
  'CURRICULUM_VISUALISER': 'curriculum visualiser',
  'PUPIL_LESSON_ACTIVITIES': 'pupil lesson activities',
  'TEACHER_LESSON_RESOURCES': 'teacher lesson resources',
  'USER_ACCOUNT_MANAGEMENT': 'user account management',
  'MEDIA_CLIPS': 'media clips',
} as const;
export type ProductType = typeof Product;
export type ProductValueType = ProductType[keyof ProductType];

export const PageName = {
  'SUBJECT_LISTING': 'Subject Listing',
  'UNIT_LISTING': 'Unit Listing',
  'HOMEPAGE': 'Homepage',
  'LESSON_LISTING': 'Lesson Listing',
  'LESSON': 'Lesson',
  'WEBINAR': 'Webinar',
  'BLOG': 'Blog',
  'PLAN_A_LESSON': 'Plan a Lesson',
  'DEVELOP_YOUR_CURRICULUM': 'Develop Your Curriculum',
  'SUPPORT_YOUR_TEAM': 'Support Your Team',
  'SEARCH': 'Search',
  'LESSON_DOWNLOAD': 'Lesson Download',
  'UNIT_DOWNLOAD': 'Unit Download',
  'BLOG_LISTING': 'Blog Listing',
  'WEBINAR_LISTING': 'Webinar Listing',
  'PROGRAMME_LISTING': 'Programme Listing',
  'CONTACT_US': 'Contact Us',
  'ABOUT_US_BOARD': 'About Us: Board',
  'ABOUT_US_WHO_WE_ARE': 'About Us: Who We Are',
  'ABOUT_US_LEADERSHIP': 'About Us: Leadership',
  'ABOUT_US_PARTNERS': 'About Us: Partners',
  'ABOUT_US_WORK_WITH_US': 'About Us: Work With Us',
  'LEGAL': 'Legal',
  'LANDING_PAGE': 'Landing Page',
  'EARLY_RELEASE_UNITS_PAGE': 'Early Release Units Page',
  'CURRICULUM_LANDING_PAGE': 'Curriculum Landing Page',
  'CURRICULUM_OVERVIEW': 'Curriculum Overview',
  'CURRICULUM_UNIT_SEQUENCE': 'Curriculum Unit Sequence',
  'CURRICULUM_DOWNLOADS': 'Curriculum Downloads',
  'LESSON_SHARE': 'Lesson Share',
  'CURRICULUM_PREVIOUS_DOWNLOADS': 'Curriculum Previous Downloads',
  'ONBOARDING_SCHOOL_SELECTION': 'Onboarding: School Selection',
  'ONBOARDING_ROLE_SELECTION': 'Onboarding: Role Selection',
  'ONBOARDING_WORK_IN_SCHOOL': 'Onboarding: Work In School',
  'ONBOARDING_USE_OF_OAK': 'Onboarding: Use Of Oak',
  'LESSON_MEDIA': 'Lesson Media',
} as const;
export type PageNameType = typeof PageName;
export type PageNameValueType = PageNameType[keyof PageNameType];

export const Platform = {
  'OWA': 'owa',
  'AILA_BETA': 'aila-beta',
} as const;
export type PlatformType = typeof Platform;
export type PlatformValueType = PlatformType[keyof PlatformType];

export const ContentGuidanceWarning = {
  'LANGUAGE_AND_DISCRIMINATION': 'Language and discrimination',
  'NUDITY_AND_SEX': 'Nudity and sex',
  'PHYSICAL_ACTIVITY_AND_EQUIPMENT_REQUIRING_SAFE_USE': 'Physical activity and equipment requiring safe use',
  'UPSETTING_DISTRIBUTING_AND_SENSITIVE': 'Upsetting, distributing and sensitive',
} as const;
export type ContentGuidanceWarningType = typeof ContentGuidanceWarning;
export type ContentGuidanceWarningValueType = ContentGuidanceWarningType[keyof ContentGuidanceWarningType];

export const Phase = {
  'PRIMARY': 'primary',
  'SECONDARY': 'secondary',
} as const;
export type PhaseType = typeof Phase;
export type PhaseValueType = PhaseType[keyof PhaseType];

export const UserRoleType = {
  'ADULT_OTHER': 'Adult (Other)',
  'EDUCATIONAL_NOT_FOR_PROFIT_PROFESSIONAL': 'Educational Not-for-Profit Professional',
  'LEA_MAT_PROFESSIONAL': 'LEA/MAT Professional',
  'NON_TEACHER': 'Non Teacher',
  'OTHER': 'Other',
  'PRIVATE_TUTOR': 'Private Tutor',
  'TEACHER': 'Teacher',
  'TEACHER_TRAINING_PROFESSIONAL': 'Teacher Training Professional',
  'TRAINEE_TEACHER': 'Trainee Teacher',
} as const;
export type UserRoleTypeType = typeof UserRoleType;
export type UserRoleTypeValueType = UserRoleTypeType[keyof UserRoleTypeType];

export const PupilExperienceLessonActivity = {
  'INTRO': 'intro',
  'VIDEO': 'video',
  'STARTER_QUIZ': 'starter-quiz',
  'EXIT_QUIZ': 'exit-quiz',
  'AUDIO': 'audio',
} as const;
export type PupilExperienceLessonActivityType = typeof PupilExperienceLessonActivity;
export type PupilExperienceLessonActivityValueType = PupilExperienceLessonActivityType[keyof PupilExperienceLessonActivityType];

export const FilterType = {
  'SUBJECT_FILTER': 'Subject filter',
  'KEY_STAGE_FILTER': 'Key stage filter',
  'CONTENT_TYPE_FILTER': 'Content type filter',
  'EXAM_BOARD_FILTER': 'Exam board filter',
  'EXAM_BOARD_TIER_FILTER': 'Exam board / tier filter',
  'LEARNING_THEME_FILTER': 'Learning theme filter',
  'TIER_FILTER': 'Tier filter',
  'YEAR_FILTER': 'Year filter',
  'PATHWAY_FILTER': 'Pathway filter',
  'LESSON_COHORT_FILTER': 'Lesson Cohort filter',
} as const;
export type FilterTypeType = typeof FilterType;
export type FilterTypeValueType = FilterTypeType[keyof FilterTypeType];

export const ShareMedium = {
  'EMAIL': 'email',
  'COPY_LINK': 'copy-link',
  'MICROSOFT_TEAMS': 'microsoft-teams',
  'GOOGLE_CLASSROOM': 'google-classroom',
  'PRINTED': 'printed',
} as const;
export type ShareMediumType = typeof ShareMedium;
export type ShareMediumValueType = ShareMediumType[keyof ShareMediumType];

export const SearchSource = {
  'HOMEPAGE_SEARCH_BOX': 'homepage search box',
  'SEARCH_PAGE_SEARCH_BOX': 'search page search box',
  'HOMEPAGE_SEARCH_SUGGESTION': 'homepage search suggestion',
} as const;
export type SearchSourceType = typeof SearchSource;
export type SearchSourceValueType = SearchSourceType[keyof SearchSourceType];

export const Pathway = {
  'CORE': 'Core',
  'GCSE': 'GCSE',
} as const;
export type PathwayType = typeof Pathway;
export type PathwayValueType = PathwayType[keyof PathwayType];

export const Audience = {
  'PUPIL': 'Pupil',
  'TEACHER': 'Teacher',
} as const;
export type AudienceType = typeof Audience;
export type AudienceValueType = AudienceType[keyof AudienceType];

export const NavigatedFrom = {
  'HEADER': 'header',
  'FOOTER': 'footer',
  'CARD': 'card',
  'MENU': 'menu',
} as const;
export type NavigatedFromType = typeof NavigatedFrom;
export type NavigatedFromValueType = NavigatedFromType[keyof NavigatedFromType];

export const KeyStageTitle = {
  'KEY_STAGE_1': 'Key stage 1',
  'KEY_STAGE_2': 'Key stage 2',
  'KEY_STAGE_3': 'Key stage 3',
  'KEY_STAGE_4': 'Key stage 4',
  'EARLY_YEARS_FOUNDATION_STAGE': 'Early Years Foundation stage',
  'SPECIALIST': 'Specialist',
  'THERAPIES': 'Therapies',
} as const;
export type KeyStageTitleType = typeof KeyStageTitle;
export type KeyStageTitleValueType = KeyStageTitleType[keyof KeyStageTitleType];

export const LearningTier = {
  'FOUNDATION': 'Foundation',
  'HIGHER': 'Higher',
} as const;
export type LearningTierType = typeof LearningTier;
export type LearningTierValueType = LearningTierType[keyof LearningTierType];

export const SearchResultType = {
  'UNIT': 'unit',
  'LESSON': 'lesson',
} as const;
export type SearchResultTypeType = typeof SearchResultType;
export type SearchResultTypeValueType = SearchResultTypeType[keyof SearchResultTypeType];

export const EngagementIntent = {
  'EXPLORE': 'explore',
  'REFINE': 'refine',
  'USE': 'use',
  'ADVOCATE': 'advocate',
} as const;
export type EngagementIntentType = typeof EngagementIntent;
export type EngagementIntentValueType = EngagementIntentType[keyof EngagementIntentType];

let PostHogEU: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    destinationOptions: any,
    PostHogEUDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    
    PostHogEU = PostHogEUDestination;
    if (__AVO_ENV__ === 'prod') {
      PostHogEU && PostHogEU.make && PostHogEU.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      PostHogEU && PostHogEU.make && PostHogEU.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for PostHogEU. Head to destination settings in Avo to set a staging key.");
      PostHogEU && PostHogEU.make && PostHogEU.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertPupilExitQuizOptional(pupilExitQuiz: PupilExitQuiz[] | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (pupilExitQuiz !== undefined && pupilExitQuiz !== null) {
    messages = messages.concat(AvoAssert.assertList("BvJKWCkFc", "Pupil Exit Quiz", pupilExitQuiz));
    pupilExitQuiz.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("BvJKWCkFc", "item at index " + index + " in Pupil Exit Quiz", value));
    });
  }
  return messages;
}

function assertTeacherSchoolManualEntryDetailsOptional(teacherSchoolManualEntryDetails: TeacherSchoolManualEntryDetails | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (teacherSchoolManualEntryDetails !== undefined && teacherSchoolManualEntryDetails !== null) {
    messages = messages.concat(AvoAssert.assertObject("FqpH5gAYj", _label ? "Teacher School Manual Entry Details" + ': ' + _label : "Teacher School Manual Entry Details", teacherSchoolManualEntryDetails));
  }
  return messages;
}

function assertPupilStarterQuizOptional(pupilStarterQuiz: PupilStarterQuiz[] | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (pupilStarterQuiz !== undefined && pupilStarterQuiz !== null) {
    messages = messages.concat(AvoAssert.assertList("GUtiqMHeN", "Pupil Starter Quiz", pupilStarterQuiz));
    pupilStarterQuiz.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("GUtiqMHeN", "item at index " + index + " in Pupil Starter Quiz", value));
    });
  }
  return messages;
}

function assertOrder(order: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("uLWinAUS-T", _label ? "Order" + ': ' + _label : "Order", order));
  messages = messages.concat(AvoAssert.assertMin("uLWinAUS-T", _label ? "Order" + ": " + _label : "Order", 0, order));
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

/**
 * Plan a Lesson Selected: Plan a lesson card is selected from the launch homepage
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6FJxOlnzBp/trigger/Hgd_u_6rr
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6FJxOlnzBp}
 */
export function planALessonSelected() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "6FJxOlnzBp", "d813096b7695f541eaa49da02cc11793ba544ce60bc41c55042e58b8fbe1ee8a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Plan a Lesson Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("6FJxOlnzBp", "Plan a Lesson Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Plan a Lesson Selected", eventProperties, "6FJxOlnzBp", "d813096b7695f541eaa49da02cc11793ba544ce60bc41c55042e58b8fbe1ee8a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Plan a Lesson Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Newsletter Sign Up Completed: A visitor submits the form to subscribe to the newsletter
 * 
 * When to trigger this event:
 * 1. User has completed the newsletter fields and pressed the Sign Up button
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/sLqKBjU-Wt/trigger/_MC_apwfp
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/sLqKBjU-Wt}
 */
export function newsletterSignUpCompleted() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sLqKBjU-Wt", "085737f624ca5a6e8b1fe99fb1015c3fcef260da5335b1f6d4da68fd8b821f74", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Newsletter Sign Up Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sLqKBjU-Wt", "Newsletter Sign Up Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Newsletter Sign Up Completed", eventProperties, "sLqKBjU-Wt", "085737f624ca5a6e8b1fe99fb1015c3fcef260da5335b1f6d4da68fd8b821f74");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Newsletter Sign Up Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClassroomSelectedProperties {
  navigatedFrom: NavigatedFromValueType;
}
/**
 * Classroom Selected: Classroom app is selected from the Launch Homepage (card or header or menu or footer)
 * 
 * When to trigger this event:
 * 1. Classroom app selected from homepage card
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/esgLdNSBsj/trigger/d46nqqMBY
 * 2. Classroom app selected from menu
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/esgLdNSBsj/trigger/M_vqoTLFQ
 * 
 * @param properties the properties associatied with this event
 * @param properties.navigatedFrom: The location of the link used to navigate to the current page
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/esgLdNSBsj}
 */
export function classroomSelected(properties: ClassroomSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "p48bLbzXJ-", name: "Navigated From", value: properties.navigatedFrom});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "esgLdNSBsj", "8ff195436fbfc616e539a0c724a8fb07de6e6e8de5ffb3561669c43b9923d029", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Classroom Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("esgLdNSBsj", "Classroom Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom Selected", eventProperties, "esgLdNSBsj", "8ff195436fbfc616e539a0c724a8fb07de6e6e8de5ffb3561669c43b9923d029");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Classroom Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherHubSelectedProperties {
  navigatedFrom: NavigatedFromValueType;
}
/**
 * Teacher Hub Selected: Teacher Hub app is selected from the Launch Homepage (card or menu)
 * 
 * When to trigger this event:
 * 1. Teacher Hub selected from homepage card
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/kp-dTd4WU3/trigger/8sYQASFRC
 * 2. Teacher Hub selected from menu
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/kp-dTd4WU3/trigger/_JhfvPPiP
 * 
 * @param properties the properties associatied with this event
 * @param properties.navigatedFrom: The location of the link used to navigate to the current page
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/kp-dTd4WU3}
 */
export function teacherHubSelected(properties: TeacherHubSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "p48bLbzXJ-", name: "Navigated From", value: properties.navigatedFrom});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "kp-dTd4WU3", "3284c81d636554f485aef25a3da0ecd34d604fd9090ea9409328d0c48fb99e95", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Hub Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("kp-dTd4WU3", "Teacher Hub Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Hub Selected", eventProperties, "kp-dTd4WU3", "3284c81d636554f485aef25a3da0ecd34d604fd9090ea9409328d0c48fb99e95");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Hub Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Develop Your Curriculum Selected: Develop your curriculum card selected from launch homepage
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/pI9xLEeG6a/trigger/dRt9RWsfe
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/pI9xLEeG6a}
 */
export function developYourCurriculumSelected() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "pI9xLEeG6a", "a3481acb261e40b56a1e7bdf228810d449934bbf71dcbf404762de914b3269a9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Develop Your Curriculum Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("pI9xLEeG6a", "Develop Your Curriculum Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Develop Your Curriculum Selected", eventProperties, "pI9xLEeG6a", "a3481acb261e40b56a1e7bdf228810d449934bbf71dcbf404762de914b3269a9");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Develop Your Curriculum Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Support Your Team Selected: Support your team card selected from launch homepage
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/LqBk-euseD/trigger/F9AZuqUAA
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/LqBk-euseD}
 */
export function supportYourTeamSelected() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "LqBk-euseD", "18e7e3d7e51df91ebbe6302f12d59500b51a22454c6e28c9fa95d092e280d9b4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Support Your Team Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("LqBk-euseD", "Support Your Team Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Support Your Team Selected", eventProperties, "LqBk-euseD", "18e7e3d7e51df91ebbe6302f12d59500b51a22454c6e28c9fa95d092e280d9b4");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Support Your Team Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NotificationSelectedProperties {
  linkUrl: string;
  notificationHeadline: string;
}
/**
 * Notification Selected: Notification card from upper right corner of launch homepage is selected 
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/M_zZRmq4zA/trigger/8JSZfjNwi
 * 
 * @param properties the properties associatied with this event
 * @param properties.linkUrl: The href of a link
 * @param properties.notificationHeadline: The heading/link text in a notification card
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/M_zZRmq4zA}
 */
export function notificationSelected(properties: NotificationSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl});
  eventPropertiesArray.push({id: "QCncIcqjhM", name: "Notification Headline", value: properties.notificationHeadline});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "M_zZRmq4zA", "f07a125a314c437a86c016adca12309399e33f5fab2d85c56397c5f9ea9e43e3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Notification Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("M_zZRmq4zA", "Notification Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Notification Selected", eventProperties, "M_zZRmq4zA", "f07a125a314c437a86c016adca12309399e33f5fab2d85c56397c5f9ea9e43e3");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Notification Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * About Selected: About us is selected from the Launch homepage
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Aj3imCEK7t}
 */
export function aboutSelected() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Aj3imCEK7t", "e9e86fc1929476c948b696d01c13c9a2a95807deb8d3b541b5ba8cbf94a96582", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("About Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Aj3imCEK7t", "About Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("About Selected", eventProperties, "Aj3imCEK7t", "e9e86fc1929476c948b696d01c13c9a2a95807deb8d3b541b5ba8cbf94a96582");
    }
    // destination PostHogEU
    PostHogEU.logEvent("About Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoStartedProperties {
  durationSeconds: number | null | undefined;
  isCaptioned: boolean;
  videoPlaybackId: string[];
  videoTitle: string;
  timeElapsedSeconds: number;
  isMuted: boolean;
  videoLocation: VideoLocationValueType | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  releaseGroup: string | null | undefined;
  phase: PhaseValueType | null | undefined;
}
/**
 * Video Started: A video is played for the first time after a user lands on a page
 * 
 * @param properties the properties associatied with this event
 * @param properties.durationSeconds: Video length in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.videoTitle: Title of video
 * @param properties.timeElapsedSeconds: Progress made through a video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.videoLocation: Where is the video on the site (eg. webinar, marketing, lesson, blog, etc)
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/G0I28K0B2f}
 */
export function videoStarted(properties: VideoStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.durationSeconds !== undefined && properties.durationSeconds !== null ?
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: properties.durationSeconds}) :
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: null});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "3a0mowzVyL", name: "Time Elapsed (Seconds)", value: properties.timeElapsedSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  properties.videoLocation !== undefined && properties.videoLocation !== null ?
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: properties.videoLocation}) :
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.releaseGroup !== undefined && properties.releaseGroup !== null ?
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup}) :
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: null});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "G0I28K0B2f", "05a51f208e963872dba00e56712a9148fc908224d6a3333b16368da9cc76094b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("G0I28K0B2f", "Video Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Started", eventProperties, "G0I28K0B2f", "05a51f208e963872dba00e56712a9148fc908224d6a3333b16368da9cc76094b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Video Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPausedProperties {
  durationSeconds: number | null | undefined;
  isCaptioned: boolean;
  videoPlaybackId: string[];
  videoTitle: string;
  timeElapsedSeconds: number;
  isMuted: boolean;
  videoLocation: VideoLocationValueType | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  releaseGroup: string | null | undefined;
  phase: PhaseValueType | null | undefined;
}
/**
 * Video Paused: A video is paused before it it finished
 * 
 * @param properties the properties associatied with this event
 * @param properties.durationSeconds: Video length in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.videoTitle: Title of video
 * @param properties.timeElapsedSeconds: Progress made through a video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.videoLocation: Where is the video on the site (eg. webinar, marketing, lesson, blog, etc)
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/z91WauKeVB}
 */
export function videoPaused(properties: VideoPausedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.durationSeconds !== undefined && properties.durationSeconds !== null ?
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: properties.durationSeconds}) :
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: null});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "3a0mowzVyL", name: "Time Elapsed (Seconds)", value: properties.timeElapsedSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  properties.videoLocation !== undefined && properties.videoLocation !== null ?
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: properties.videoLocation}) :
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.releaseGroup !== undefined && properties.releaseGroup !== null ?
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup}) :
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: null});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "z91WauKeVB", "627481a60bea296ebb1967797ceacf1ee18222e4192ee7c8f8f5a45a440fcdb9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Paused", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("z91WauKeVB", "Video Paused", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Paused", eventProperties, "z91WauKeVB", "627481a60bea296ebb1967797ceacf1ee18222e4192ee7c8f8f5a45a440fcdb9");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Video Paused", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlayedProperties {
  durationSeconds: number | null | undefined;
  isCaptioned: boolean;
  videoPlaybackId: string[];
  videoTitle: string;
  timeElapsedSeconds: number;
  isMuted: boolean;
  videoLocation: VideoLocationValueType | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  releaseGroup: string | null | undefined;
  phase: PhaseValueType | null | undefined;
}
/**
 * Video Played: A video is played again after being paused
 * 
 * @param properties the properties associatied with this event
 * @param properties.durationSeconds: Video length in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.videoTitle: Title of video
 * @param properties.timeElapsedSeconds: Progress made through a video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.videoLocation: Where is the video on the site (eg. webinar, marketing, lesson, blog, etc)
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/r4DFADUHFh}
 */
export function videoPlayed(properties: VideoPlayedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.durationSeconds !== undefined && properties.durationSeconds !== null ?
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: properties.durationSeconds}) :
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: null});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "3a0mowzVyL", name: "Time Elapsed (Seconds)", value: properties.timeElapsedSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  properties.videoLocation !== undefined && properties.videoLocation !== null ?
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: properties.videoLocation}) :
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.releaseGroup !== undefined && properties.releaseGroup !== null ?
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup}) :
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: null});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "r4DFADUHFh", "cc643fdfc1c4d324c0deffa22d5ce2d7f7366debbccb6e94b4cbd9a271d8ec0a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Played", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("r4DFADUHFh", "Video Played", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Played", eventProperties, "r4DFADUHFh", "cc643fdfc1c4d324c0deffa22d5ce2d7f7366debbccb6e94b4cbd9a271d8ec0a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Video Played", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoFinishedProperties {
  durationSeconds: number | null | undefined;
  isCaptioned: boolean;
  videoPlaybackId: string[];
  videoTitle: string;
  timeElapsedSeconds: number;
  isMuted: boolean;
  videoLocation: VideoLocationValueType | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  phase: PhaseValueType | null | undefined;
  releaseGroup: string | null | undefined;
}
/**
 * Video Finished: The end of a video is reached
 * 
 * @param properties the properties associatied with this event
 * @param properties.durationSeconds: Video length in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.videoTitle: Title of video
 * @param properties.timeElapsedSeconds: Progress made through a video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.videoLocation: Where is the video on the site (eg. webinar, marketing, lesson, blog, etc)
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/NP9klWkaki}
 */
export function videoFinished(properties: VideoFinishedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.durationSeconds !== undefined && properties.durationSeconds !== null ?
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: properties.durationSeconds}) :
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: null});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "3a0mowzVyL", name: "Time Elapsed (Seconds)", value: properties.timeElapsedSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  properties.videoLocation !== undefined && properties.videoLocation !== null ?
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: properties.videoLocation}) :
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  properties.releaseGroup !== undefined && properties.releaseGroup !== null ?
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup}) :
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "NP9klWkaki", "9e049febaa30a91f9548773440a9e85026be3b803334540c46eca5c45302bd9b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Finished", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("NP9klWkaki", "Video Finished", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Finished", eventProperties, "NP9klWkaki", "9e049febaa30a91f9548773440a9e85026be3b803334540c46eca5c45302bd9b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Video Finished", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonResourcesDownloadedProperties {
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  schoolUrn: string;
  schoolName: string;
  schoolOption: SchoolOptionValueType;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType;
  resourceType: ResourceTypeValueType[];
  emailSupplied: boolean;
  onwardContent: string[];
}
/**
 * Lesson Resources Downloaded: A user downloaded one or more resources for a lesson
 * 
 * When to trigger this event:
 * 1. The download .zip button is clicked on the lesson download page and submission passes validation checks
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/k9ZQJai7ws/trigger/sAqordxVG
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.schoolUrn: School URN linked to GIAS attributes, should match regex: ^\d{3}\-?\d{3,4}$
 * @param properties.schoolName: Name of the school chosen from the school picker
 * @param properties.schoolOption: The option the user has selected as their school (selected school, homeschool or not listed)
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.resourceType: The lesson resources a teacher selected for download.
 * @param properties.emailSupplied: A user has signed up for updates on the downloads page
 * @param properties.onwardContent: A list of slugs representing content (e.g. lessons) that are placed to allow a user journey to 'continue' onward.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/k9ZQJai7ws}
 */
export function lessonResourcesDownloaded(properties: LessonResourcesDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "G1iO4wRoL5", name: "School URN", value: properties.schoolUrn});
  eventPropertiesArray.push({id: "54PPZ-gkS", name: "School Name", value: properties.schoolName});
  eventPropertiesArray.push({id: "CrzKvLBC3", name: "School Option", value: properties.schoolOption});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway});
  eventPropertiesArray.push({id: "H_kc7WuVNP", name: "Resource Type", value: properties.resourceType});
  eventPropertiesArray.push({id: "3wxlGffcE", name: "Email Supplied", value: properties.emailSupplied});
  eventPropertiesArray.push({id: "5IrIuSjxs", name: "Onward Content", value: properties.onwardContent});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "k9ZQJai7ws", "8296d44de6200f0b8af74073f8275d6f9d733c548092883693512d998e511a24", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Resources Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("k9ZQJai7ws", "Lesson Resources Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Resources Downloaded", eventProperties, "k9ZQJai7ws", "8296d44de6200f0b8af74073f8275d6f9d733c548092883693512d998e511a24");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Resources Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface KeyStageSelectedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  navigatedFrom: NavigatedFromValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Key Stage Selected: A user chooses the key stage they want to view.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/7ONADbQPez/trigger/bkIRr49k7
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.navigatedFrom: The location of the link used to navigate to the current page
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/7ONADbQPez}
 */
export function keyStageSelected(properties: KeyStageSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "p48bLbzXJ-", name: "Navigated From", value: properties.navigatedFrom});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "7ONADbQPez", "864ff27cecc8d9dd85d466ec6a9ed34e4f434aa8b1b51dcba4dee407b0035bee", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Key Stage Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("7ONADbQPez", "Key Stage Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Key Stage Selected", eventProperties, "7ONADbQPez", "864ff27cecc8d9dd85d466ec6a9ed34e4f434aa8b1b51dcba4dee407b0035bee");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Key Stage Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SubjectSelectedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Subject Selected: A teacher chooses the subject they want to view.
 * 
 * When to trigger this event:
 * 1. One of the yellow subject cards is selected
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/ufkcMq0HT4/trigger/Pl87P0XPk
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/ufkcMq0HT4}
 */
export function subjectSelected(properties: SubjectSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ufkcMq0HT4", "fd1adbbe4ea28151b20a16adaf01a6109ee34e2a627e4ccad18ba84038ac4194", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Subject Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ufkcMq0HT4", "Subject Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Subject Selected", eventProperties, "ufkcMq0HT4", "fd1adbbe4ea28151b20a16adaf01a6109ee34e2a627e4ccad18ba84038ac4194");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Subject Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UnitAccessedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  unitName: string;
  unitSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
}
/**
 * Unit Accessed: A teacher chooses the unit they want to view.
 * 
 * When to trigger this event:
 * 1. A unit card is selected from the unit listing page
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Me4ouIgPxh/trigger/t8lbfIsGe
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Me4ouIgPxh}
 */
export function unitAccessed(properties: UnitAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Me4ouIgPxh", "e5a441c4ea81104bb8f1e09b8e220398ab9b2788dc3b2dacb764ed9fad96d2ed", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Unit Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Me4ouIgPxh", "Unit Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unit Accessed", eventProperties, "Me4ouIgPxh", "e5a441c4ea81104bb8f1e09b8e220398ab9b2788dc3b2dacb764ed9fad96d2ed");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Unit Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonSelectedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Lesson Selected: A teacher chooses a lesson they want to view
 * 
 * When to trigger this event:
 * 1. Lesson is selected from listing page
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/iUvld79OSb/trigger/TnGi5eBdB
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/iUvld79OSb}
 */
export function lessonSelected(properties: LessonSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "iUvld79OSb", "52826208f39cf7427cc6cd2067d1a1d58b4ce0d2e57f257f25dcd9cceb1f3c3d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("iUvld79OSb", "Lesson Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Selected", eventProperties, "iUvld79OSb", "52826208f39cf7427cc6cd2067d1a1d58b4ce0d2e57f257f25dcd9cceb1f3c3d");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UnitSequenceRefinedProperties {
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  subjectTitle: string;
  subjectSlug: string;
  threadTitle: string | null | undefined;
  threadSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  childSubjectSlug: string | null | undefined;
  childSubjectName: string | null | undefined;
  phase: PhaseValueType;
  learningTier: LearningTierValueType | null | undefined;
  subjectCategory: string | null | undefined;
}
/**
 * Unit Sequence Refined: A user of the curriculum visualiser narrows down the units that are displayed in some way. 
 * 
 * When to trigger this event:
 * 1. An example of year group being selected from within the curriculum visualiser tool
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6DwKZEuYUk/trigger/Y36tMwp1l
 * 2. User selects a learning tier
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6DwKZEuYUk/trigger/wNnLPxDLB
 * 3. User selects a subject category
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6DwKZEuYUk/trigger/6ah3h300p
 * 4. Another example of year group being selected within the curriculum visualiser tool (new layout).
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6DwKZEuYUk/trigger/83b58SsoMa00aIvxdXAc8
 * 5. New way of user selecting subject category - selecting one of the buttons on the left menu
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6DwKZEuYUk/trigger/YJGa0DxCzKH6WnBCKuAHX
 * 6. Another example of how the user can select a Learning Tier - on button click
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6DwKZEuYUk/trigger/JVy21DEdSwv_cJGcwWhht
 * 7. User selects one of the Exam subjects - button click
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6DwKZEuYUk/trigger/xbLsT77YcTEO3WXlZDRvM
 * 
 * @param properties the properties associatied with this event
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.threadTitle: The title (in plain English including spaces) of a thread corresponding to a sequence of lessons across units
 * @param properties.threadSlug: The human readable identifier (n-kebab-case) for a sequence of lessons
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.childSubjectSlug: Slug of Child Subject associated with the event
 * @param properties.childSubjectName: Name of the Child Subject Associated with the event
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.learningTier: Learning tier that was selected
 * @param properties.subjectCategory: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6DwKZEuYUk}
 */
export function unitSequenceRefined(properties: UnitSequenceRefinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.threadTitle !== undefined && properties.threadTitle !== null ?
    eventPropertiesArray.push({id: "5vqHiL5Sh", name: "Thread Title", value: properties.threadTitle}) :
    eventPropertiesArray.push({id: "5vqHiL5Sh", name: "Thread Title", value: null});
  properties.threadSlug !== undefined && properties.threadSlug !== null ?
    eventPropertiesArray.push({id: "E1mlACg_OT", name: "Thread Slug", value: properties.threadSlug}) :
    eventPropertiesArray.push({id: "E1mlACg_OT", name: "Thread Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.childSubjectSlug !== undefined && properties.childSubjectSlug !== null ?
    eventPropertiesArray.push({id: "S4dKDojap", name: "Child Subject Slug", value: properties.childSubjectSlug}) :
    eventPropertiesArray.push({id: "S4dKDojap", name: "Child Subject Slug", value: null});
  properties.childSubjectName !== undefined && properties.childSubjectName !== null ?
    eventPropertiesArray.push({id: "5QAyZtsHD", name: "Child Subject Name", value: properties.childSubjectName}) :
    eventPropertiesArray.push({id: "5QAyZtsHD", name: "Child Subject Name", value: null});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  properties.learningTier !== undefined && properties.learningTier !== null ?
    eventPropertiesArray.push({id: "uWHOnx61K", name: "Learning Tier", value: properties.learningTier}) :
    eventPropertiesArray.push({id: "uWHOnx61K", name: "Learning Tier", value: null});
  properties.subjectCategory !== undefined && properties.subjectCategory !== null ?
    eventPropertiesArray.push({id: "PGhVxy16A", name: "Subject Category", value: properties.subjectCategory}) :
    eventPropertiesArray.push({id: "PGhVxy16A", name: "Subject Category", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "6DwKZEuYUk", "b535bf9ebf27f3d64a5681519583243052251108a3487265ba53bc09ca840602", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Unit Sequence Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("6DwKZEuYUk", "Unit Sequence Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unit Sequence Refined", eventProperties, "6DwKZEuYUk", "b535bf9ebf27f3d64a5681519583243052251108a3487265ba53bc09ca840602");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Unit Sequence Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WebinarPageViewedProperties {
  webinarTitle: string;
  webinarCategory: string;
  videoAvailable: boolean;
}
/**
 * Webinar Page Viewed: A user loads a webinar page
 * 
 * @param properties the properties associatied with this event
 * @param properties.webinarTitle: Title of the webinar
 * @param properties.webinarCategory: Category of the webinar
 * @param properties.videoAvailable: Watchable video is available on page (eg. not 'upcoming' or 'processing' status
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/-9FHudlATb}
 */
export function webinarPageViewed(properties: WebinarPageViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "EEuyiIwAD", name: "Webinar Title", value: properties.webinarTitle});
  eventPropertiesArray.push({id: "MbEsLei6Z", name: "Webinar Category", value: properties.webinarCategory});
  eventPropertiesArray.push({id: "StT0U3M69", name: "Video Available", value: properties.videoAvailable});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "-9FHudlATb", "ebf8f74a217a39aefe9153d249e65dfd00927a93e0811de345e3edf20dc2ed39", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Webinar Page Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("-9FHudlATb", "Webinar Page Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Webinar Page Viewed", eventProperties, "-9FHudlATb", "ebf8f74a217a39aefe9153d249e65dfd00927a93e0811de345e3edf20dc2ed39");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Webinar Page Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Help Centre Selected: Visit help centre button is clicked on the homepage
 * 
 * When to trigger this event:
 * 1. Visit help centre button clicked
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Ls0Ou1w7qK/trigger/RAhU-otN8
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Ls0Ou1w7qK}
 */
export function helpCentreSelected() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Ls0Ou1w7qK", "56af691cf1453c2843da2e84c18c26aba60176dbd8f88253c13780a664026e16", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Help Centre Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Ls0Ou1w7qK", "Help Centre Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Help Centre Selected", eventProperties, "Ls0Ou1w7qK", "56af691cf1453c2843da2e84c18c26aba60176dbd8f88253c13780a664026e16");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Help Centre Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TierSelectedProperties {
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  tierName: TierNameValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Tier Selected: A user makes a tier choice to show a grouping of units
 * 
 * When to trigger this event:
 * 1. On the unit page a Learning tier is selected

NB. This currently only impacts KS4 Maths, but is expected to also impact KS4 Sciences once the new content is introduced
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6lyU_rQz42/trigger/HHKzuwVa4
 * 
 * @param properties the properties associatied with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.tierName: Name of the learning tier
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/6lyU_rQz42}
 */
export function tierSelected(properties: TierSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "6lyU_rQz42", "97c015632357cdf3512711159779ddb69f51215787f93abf95a099875db6d1e4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Tier Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("6lyU_rQz42", "Tier Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tier Selected", eventProperties, "6lyU_rQz42", "97c015632357cdf3512711159779ddb69f51215787f93abf95a099875db6d1e4");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Tier Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PageviewProperties {
  linkUrl: string;
  analyticsUseCase: AnalyticsUseCaseValueType | null | undefined;
  pageName: PageNameValueType;
}
/**
 * $pageview: A user views the page (DO NOT change the name of this event, as it is a special name in Posthog)
 * 
 * @param properties the properties associatied with this event
 * @param properties.linkUrl: The href of a link
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pageName: The main pages of a user journey eg. subject listing, unit listing, etc
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/iYVEEwNT0q}
 */
export function pageview(properties: PageviewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl});
  properties.analyticsUseCase !== undefined && properties.analyticsUseCase !== null ?
    eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase}) :
    eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: null});
  eventPropertiesArray.push({id: "LgWcfE0FOm", name: "Page Name", value: properties.pageName});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "iYVEEwNT0q", "edb82ae5cbbdf4470c80e0a9c2609a452fbebfb9f5d335817e85dd1c328f4a02", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("$pageview", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("iYVEEwNT0q", "$pageview", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("$pageview", eventProperties, "iYVEEwNT0q", "edb82ae5cbbdf4470c80e0a9c2609a452fbebfb9f5d335817e85dd1c328f4a02");
    }
    // destination PostHogEU
    PostHogEU.logEvent("$pageview", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ResourceContainerExpandedProperties {
  analyticsUseCase: AnalyticsUseCaseValueType;
  pageName: PageNameValueType;
  containerTitle: string;
}
/**
 * Resource Container Expanded: A resource container is expanded to expose the lesson resource content
 * 
 * When to trigger this event:
 * 1. A container chevron is expanded to allow a view of the resource.

NB. resource could be attached at a lesson or unit level. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/B-ti6Ajp8/trigger/57LUx8uOY
 * 
 * @param properties the properties associatied with this event
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pageName: The main pages of a user journey eg. subject listing, unit listing, etc
 * @param properties.containerTitle: The title of the container bar.
eg. Slide deck, Worksheet, Video, Starter quiz, Exit quiz, Unit quiz, Transcript, Lesson overview
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/B-ti6Ajp8}
 */
export function resourceContainerExpanded(properties: ResourceContainerExpandedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "LgWcfE0FOm", name: "Page Name", value: properties.pageName});
  eventPropertiesArray.push({id: "o3aX6Ur5U", name: "Container Title", value: properties.containerTitle});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "B-ti6Ajp8", "aa3adefb4ebc4211cc2e874602ad19ca2ab0e64f805631e9b017f98664a96fa7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Resource Container Expanded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("B-ti6Ajp8", "Resource Container Expanded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Resource Container Expanded", eventProperties, "B-ti6Ajp8", "aa3adefb4ebc4211cc2e874602ad19ca2ab0e64f805631e9b017f98664a96fa7");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Resource Container Expanded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumMapDownloadedProperties {
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pageName: PageNameValueType;
}
/**
 * Curriculum Map Downloaded: A user downloads a curriculum map on a unit listing or a lesson listing page
 * 
 * When to trigger this event:
 * 1. User clicks the Curriculum download (PDF) button on a unit listing page
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/W9R2vOSii_/trigger/l30pZnEW3
 * 2. User clicks the Curriculum download (PDF) button on a lesson listing page
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/W9R2vOSii_/trigger/0LJTo1tA3
 * 
 * @param properties the properties associatied with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pageName: The main pages of a user journey eg. subject listing, unit listing, etc
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/W9R2vOSii_}
 */
export function curriculumMapDownloaded(properties: CurriculumMapDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "LgWcfE0FOm", name: "Page Name", value: properties.pageName});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "W9R2vOSii_", "18b9e54e2f10c41d724f1c277fadcdf490412da43799da4f032018adf3db0e9b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Map Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("W9R2vOSii_", "Curriculum Map Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Map Downloaded", eventProperties, "W9R2vOSii_", "18b9e54e2f10c41d724f1c277fadcdf490412da43799da4f032018adf3db0e9b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Map Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonResourceDownloadStartedProperties {
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  downloadResourceButtonName: DownloadResourceButtonNameValueType;
}
/**
 * Lesson Resource Download Started: A download button is clicked on the lesson overview page
 * 
 * When to trigger this event:
 * 1. Download all resources button is clicked on the lesson overview page
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/0n50tfMg2N/trigger/w2ACuk2F3
 * 2. An individual resource download button on an expandable container is clicked (eg. slide deck, starter quiz, worksheet, etc)
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/0n50tfMg2N/trigger/5PBz6j66G
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.downloadResourceButtonName: The name of the button to download the resource (all, or individual resources)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/0n50tfMg2N}
 */
export function lessonResourceDownloadStarted(properties: LessonResourceDownloadStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "GeeELBAAq", name: "Download Resource Button Name", value: properties.downloadResourceButtonName});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0n50tfMg2N", "7f8099997906c22a20c40ed3dcbfa2ecb74c541eb51ef290b921ebea9b29c59b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Resource Download Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0n50tfMg2N", "Lesson Resource Download Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Resource Download Started", eventProperties, "0n50tfMg2N", "7f8099997906c22a20c40ed3dcbfa2ecb74c541eb51ef290b921ebea9b29c59b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Resource Download Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  searchTerm: string;
  searchResultCount: number;
  searchResultsLoadTime: number;
}
/**
 * Search Accessed: A user enters a search term (eg. lesson or unit topic, keyword), submits a search, and results are rendered
 * 
 * When to trigger this event:
 * 1. A user initiates a search from the homepage by 
entering the search term and clicking "Go"
entering the search term and pressing ENTER on the keyboard
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/I_dSzYI2PB/trigger/GRZ05_zLD
 * 2. A user initiates a search from the search page (eg. they refine their search term or try looking for something else) by entering the search term and 
clicking "Go", or 
pressing ENTER 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/I_dSzYI2PB/trigger/SG8O6HFoP
 * 3. A search is initiated from the homepage by clicking on one of the search suggestion option beneath the search box
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/I_dSzYI2PB/trigger/5gULgsDoY
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.searchTerm: The term entered by the user for the search.
 * @param properties.searchResultCount: total number of search results returned
 * @param properties.searchResultsLoadTime: Amount of time taken to fetch and load the search results
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/I_dSzYI2PB}
 */
export function searchAccessed(properties: SearchAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "hHufJiP_N", name: "Search Term", value: properties.searchTerm});
  eventPropertiesArray.push({id: "ssKpAufWU", name: "Search Result Count", value: properties.searchResultCount});
  eventPropertiesArray.push({id: "uKpVoe2qJ", name: "Search Results Load Time", value: properties.searchResultsLoadTime});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "I_dSzYI2PB", "5d99ff7c4ea0ffb7aa04290175a6be884f12478f8749e0493adbd4cf1d7d1e6d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("I_dSzYI2PB", "Search Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Accessed", eventProperties, "I_dSzYI2PB", "5d99ff7c4ea0ffb7aa04290175a6be884f12478f8749e0493adbd4cf1d7d1e6d");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchResultOpenedProperties {
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  analyticsUseCase: AnalyticsUseCaseValueType;
  searchRank: number;
  searchFilterOptionSelected: string[];
  searchResultCount: number;
  searchResultType: SearchResultTypeValueType;
  context: ContextValueType;
}
/**
 * Search Result Opened: User clicks on a search result from the listing
 * 
 * When to trigger this event:
 * 1. A search result card (could be unit or lesson) is clicked
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/_TD-gtSgIj/trigger/ZezXTZ0ri
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.searchRank: The position of the clicked search result
 * @param properties.searchFilterOptionSelected: The specific search filter option that has been selected (eg. 'ks2,ks3') 
NB. ensure filters are sent in a consistent order
 * @param properties.searchResultCount: total number of search results returned
 * @param properties.searchResultType: The type of result returned (eg. unit or lesson)
 * @param properties.context: Relates to the application or view from which a action was performed
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/_TD-gtSgIj}
 */
export function searchResultOpened(properties: SearchResultOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Gvu_40yW7", name: "Search Rank", value: properties.searchRank});
  eventPropertiesArray.push({id: "psOVldb0Z", name: "Search Filter Option Selected", value: properties.searchFilterOptionSelected});
  eventPropertiesArray.push({id: "ssKpAufWU", name: "Search Result Count", value: properties.searchResultCount});
  eventPropertiesArray.push({id: "weaA0iE9I", name: "Search Result Type", value: properties.searchResultType});
  eventPropertiesArray.push({id: "9BNUma5en", name: "Context", value: properties.context});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_TD-gtSgIj", "800b968d9e28db54e9dae4d1c4cb2fa2547a0af189baa0492fe95de59f32a298", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Result Opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_TD-gtSgIj", "Search Result Opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Result Opened", eventProperties, "_TD-gtSgIj", "800b968d9e28db54e9dae4d1c4cb2fa2547a0af189baa0492fe95de59f32a298");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Result Opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchJourneyInitiatedProperties {
  searchSource: SearchSourceValueType;
  context: ContextValueType;
}
/**
 * Search Journey Initiated: The search box is selected
 * 
 * When to trigger this event:
 * 1. A user types in the search bar on the homepage (first letter is typed).
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/rYxJBK8Kpm/trigger/aeEheVqLW
 * 2. A user types in the search bar on the search page (first letter is typed)
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/rYxJBK8Kpm/trigger/5OM1jFoWf
 * 
 * @param properties the properties associatied with this event
 * @param properties.searchSource: The location of the search box/entry point. 
eg. homepage search box, search page search box, hamburger menu search box (future)
 * @param properties.context: Relates to the application or view from which a action was performed
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/rYxJBK8Kpm}
 */
export function searchJourneyInitiated(properties: SearchJourneyInitiatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "cAhJwc7aw", name: "Search Source", value: properties.searchSource});
  eventPropertiesArray.push({id: "9BNUma5en", name: "Context", value: properties.context});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rYxJBK8Kpm", "006d2562e0107acacb267f0facf567771921d7c7151c3853af18c57c38437ce3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Journey Initiated", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rYxJBK8Kpm", "Search Journey Initiated", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Journey Initiated", eventProperties, "rYxJBK8Kpm", "006d2562e0107acacb267f0facf567771921d7c7151c3853af18c57c38437ce3");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Journey Initiated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumVisualiserAccessedProperties {
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
}
/**
 * Curriculum Visualiser Accessed: A user opening the curriculum visualiser tool for use having select a subject and phase.
 * 
 * When to trigger this event:
 * 1. A user has clicked view after successfully completing the "Subject" and "School phase" fields.
Component Type: 'homepage_button'
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/_ImUDkApb7/trigger/R19ayisHj
 * 2. Illustration of same component with would trigger this event but this time from the curriculum visualiser itself where this event could also be triggered
component: curriculum_visualiser_button
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/_ImUDkApb7/trigger/LFOFUdkpr
 * 3. The lot picker is also accessible from the curriculum landing page
component type: 'landing_page_button'
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/_ImUDkApb7/trigger/vCEJO0o_GAdCNaTlSlkoP
 * 
 * @param properties the properties associatied with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/_ImUDkApb7}
 */
export function curriculumVisualiserAccessed(properties: CurriculumVisualiserAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_ImUDkApb7", "f2cf20d154bab2b00496502995c9e6e27f727a8393df6514af62e592c9af11fa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Visualiser Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_ImUDkApb7", "Curriculum Visualiser Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Visualiser Accessed", eventProperties, "_ImUDkApb7", "f2cf20d154bab2b00496502995c9e6e27f727a8393df6514af62e592c9af11fa");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Visualiser Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProgrammeThreadHighlightedProperties {
  subjectTitle: string;
  subjectSlug: string;
  threadTitle: string;
  threadSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
  order: number;
}
/**
 * Programme Thread Highlighted: A unit thread is highlighted using the curriculum visualiser
 * 
 * When to trigger this event:
 * 1. item div is clicked whilst curriculum visualiser is open
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/sR1S6swOBk/trigger/0ajfpuq__
 * 
 * @param properties the properties associatied with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.threadTitle: The title (in plain English including spaces) of a thread corresponding to a sequence of lessons across units
 * @param properties.threadSlug: The human readable identifier (n-kebab-case) for a sequence of lessons
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.order: The position of the item within a list
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/sR1S6swOBk}
 */
export function programmeThreadHighlighted(properties: ProgrammeThreadHighlightedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "5vqHiL5Sh", name: "Thread Title", value: properties.threadTitle});
  eventPropertiesArray.push({id: "E1mlACg_OT", name: "Thread Slug", value: properties.threadSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "uLWinAUS-T", name: "Order", value: properties.order});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertOrder(properties.order));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sR1S6swOBk", "64752eede7d31ebf32b450c3f528106952b51d66efe598761a107385511229f4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Programme Thread Highlighted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sR1S6swOBk", "Programme Thread Highlighted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Programme Thread Highlighted': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Programme Thread Highlighted", eventProperties, "sR1S6swOBk", "64752eede7d31ebf32b450c3f528106952b51d66efe598761a107385511229f4");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Programme Thread Highlighted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UnitOverviewAccessedProperties {
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  threadTitle: string | null | undefined;
  threadSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  unitHighlighted: boolean;
  isUnitPublished: boolean;
}
/**
 * Unit Overview Accessed: A user of the curriculum visualiser views information relating to a highlighted (or non-highlighted) unit
 * 
 * When to trigger this event:
 * 1. Unit info div is selected on div corresponding to a particular unit (in this case one that is highlighted a resulted of the selected thread)
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/OnjKTo8kYs/trigger/I6HnzeUNk
 * 
 * @param properties the properties associatied with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.threadTitle: The title (in plain English including spaces) of a thread corresponding to a sequence of lessons across units
 * @param properties.threadSlug: The human readable identifier (n-kebab-case) for a sequence of lessons
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.unitHighlighted: A boolean describing whether a given unit is highlighted when unit information is viewed
 * @param properties.isUnitPublished: A boolean describing whether the unit has been published and therefore it is possible to click through to the unit listing page (i.e. the 'See lessons in Unit' button is active)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/OnjKTo8kYs}
 */
export function unitOverviewAccessed(properties: UnitOverviewAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.threadTitle !== undefined && properties.threadTitle !== null ?
    eventPropertiesArray.push({id: "5vqHiL5Sh", name: "Thread Title", value: properties.threadTitle}) :
    eventPropertiesArray.push({id: "5vqHiL5Sh", name: "Thread Title", value: null});
  properties.threadSlug !== undefined && properties.threadSlug !== null ?
    eventPropertiesArray.push({id: "E1mlACg_OT", name: "Thread Slug", value: properties.threadSlug}) :
    eventPropertiesArray.push({id: "E1mlACg_OT", name: "Thread Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "WIkFSM1sX", name: "Unit Highlighted", value: properties.unitHighlighted});
  eventPropertiesArray.push({id: "nWQ6pH3L0", name: "Is Unit Published", value: properties.isUnitPublished});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "OnjKTo8kYs", "863a22f3893eab3acbfe424fc0e538b6441cc45b87951e252014dbca241793b4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Unit Overview Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("OnjKTo8kYs", "Unit Overview Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unit Overview Accessed", eventProperties, "OnjKTo8kYs", "863a22f3893eab3acbfe424fc0e538b6441cc45b87951e252014dbca241793b4");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Unit Overview Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnwardContentSelectedProperties {
  unitName: string;
  unitSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  onwardIntent: OnwardIntentValueType;
}
/**
 * Onward Content Selected: Triggered when user continues their journey following the presentation of potential content of interest. In case of download or lesson view, lesson fields are populated. In case of unit being viewed unit fields are populated.
 * 
 * When to trigger this event:
 * 1. Onward Content presentation screen following the download of a resource. Any of the links highlighted below would trigger this event.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/H9jrWEk8wy/trigger/t_FkWxgTH
 * 
 * @param properties the properties associatied with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.onwardIntent: Describes the intent of the action when a user journey continues following the presentation of relevant content
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/H9jrWEk8wy}
 */
export function onwardContentSelected(properties: OnwardContentSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "CC9YnUSeo", name: "Onward Intent", value: properties.onwardIntent});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "H9jrWEk8wy", "91840f841719f36ff0efbb628b78eb4bd72295ee49feb0d9f90a90e1da895b84", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onward Content Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("H9jrWEk8wy", "Onward Content Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onward Content Selected", eventProperties, "H9jrWEk8wy", "91840f841719f36ff0efbb628b78eb4bd72295ee49feb0d9f90a90e1da895b84");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Onward Content Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonSharedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  schoolUrn: string;
  schoolName: string;
  schoolOption: SchoolOptionValueType;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  shareMedium: ShareMediumValueType;
  resourceTypes: ResourceTypesValueType[];
  emailSupplied: boolean;
  audience: AudienceValueType;
}
/**
 * Lesson Shared: The event of a teacher sharing a selection of resources relating to a lesson with pupils or elsewhere.
 * 
 * When to trigger this event:
 * 1. One of the share options is selected
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/RnJu4EY4bA/trigger/lvtGVFDJo
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.schoolUrn: School URN linked to GIAS attributes, should match regex: ^\d{3}\-?\d{3,4}$
 * @param properties.schoolName: Name of the school chosen from the school picker
 * @param properties.schoolOption: The option the user has selected as their school (selected school, homeschool or not listed)
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.shareMedium: The medium through which a link to a resource is shared
 * @param properties.resourceTypes: The type of pupil facing activity(yes) selected (e.g. when a lesson is shared with pupils)
 * @param properties.emailSupplied: A user has signed up for updates on the downloads page
 * @param properties.audience: Corresponds to the a target audience (usually in relation to a share event)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/RnJu4EY4bA}
 */
export function lessonShared(properties: LessonSharedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "G1iO4wRoL5", name: "School URN", value: properties.schoolUrn});
  eventPropertiesArray.push({id: "54PPZ-gkS", name: "School Name", value: properties.schoolName});
  eventPropertiesArray.push({id: "CrzKvLBC3", name: "School Option", value: properties.schoolOption});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "aMDyFQBYq", name: "Share Medium", value: properties.shareMedium});
  eventPropertiesArray.push({id: "4Vptzwuw7", name: "Resource Types", value: properties.resourceTypes});
  eventPropertiesArray.push({id: "3wxlGffcE", name: "Email Supplied", value: properties.emailSupplied});
  eventPropertiesArray.push({id: "n6WxfUPK1", name: "Audience", value: properties.audience});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "RnJu4EY4bA", "8570b0d578a87f5f6acba8ed9edc7b5e711e75acb1f853406177ba205f1ea3ba", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Shared", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("RnJu4EY4bA", "Lesson Shared", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Shared", eventProperties, "RnJu4EY4bA", "8570b0d578a87f5f6acba8ed9edc7b5e711e75acb1f853406177ba205f1ea3ba");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Shared", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonShareStartedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
}
/**
 * Lesson Share Started: A user beings the process of sharing a lesson with their pupils. This event shows they are interested in sharing something but happens prior to a user generating the required link that would suggest the sharing has taken place.
 * 
 * When to trigger this event:
 * 1. Share activities with pupils button clicked at top of the page
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/PS8tcnGrN2/trigger/Lsaaeanis
 * 2. Share activities with pupils button clicked at the resource level

NB. There is no sharing of slide decks at this time
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/PS8tcnGrN2/trigger/QMYuEgDaG
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/PS8tcnGrN2}
 */
export function lessonShareStarted(properties: LessonShareStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "PS8tcnGrN2", "28694d3cd14fddb46dea226070b3af410bd127585f43afd95f5ca43581b988c2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Share Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("PS8tcnGrN2", "Lesson Share Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Share Started", eventProperties, "PS8tcnGrN2", "28694d3cd14fddb46dea226070b3af410bd127585f43afd95f5ca43581b988c2");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Share Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchRefinedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  searchResultCount: number;
  activeFilters: ActiveFilters;
  searchTerm: string;
}
/**
 * Search Refined: Results are returned following a change to search filters
 * 
 * When to trigger this event:
 * 1. Results are returned by the search and a count of results is known
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/XpQ27vPNH4/trigger/PcgndFCLH2PP2U6ErGXCe
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.searchResultCount: total number of search results returned
 * @param properties.activeFilters: The filters that are active at the time of the refinement event. Small json object in the form

```json
{
  'key_stage': [...key_stage_titles],
  'exam_board': […exam_board_titles],
  'subjects': […subject_titles],
  'content_types': […content_type] // should be one of ['units', 'lessons'] for now
}
```

Only include keys/values for active filters.
 * @param properties.searchTerm: The term entered by the user for the search.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/XpQ27vPNH4}
 */
export function searchRefined(properties: SearchRefinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ssKpAufWU", name: "Search Result Count", value: properties.searchResultCount});
  eventPropertiesArray.push({id: "TsVyKpbQ6", name: "Active Filters", value: properties.activeFilters});
  eventPropertiesArray.push({id: "hHufJiP_N", name: "Search Term", value: properties.searchTerm});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "XpQ27vPNH4", "84b5f572b43efb07cd4a1c29c4e6d3e0eb15df73254a706c53087e14b7240a93", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("XpQ27vPNH4", "Search Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Refined", eventProperties, "XpQ27vPNH4", "84b5f572b43efb07cd4a1c29c4e6d3e0eb15df73254a706c53087e14b7240a93");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchResultExpandedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  unitName: string;
  unitSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  context: ContextValueType;
  searchRank: number;
  searchFilterOptionSelected: string[];
  searchResultCount: number;
  searchResultType: SearchResultTypeValueType;
}
/**
 * Search Result Expanded: The User expands a search result to display optionality around Exam Board or difficulty
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.context: Relates to the application or view from which a action was performed
 * @param properties.searchRank: The position of the clicked search result
 * @param properties.searchFilterOptionSelected: The specific search filter option that has been selected (eg. 'ks2,ks3') 
NB. ensure filters are sent in a consistent order
 * @param properties.searchResultCount: total number of search results returned
 * @param properties.searchResultType: The type of result returned (eg. unit or lesson)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/eP2lOQQj8C}
 */
export function searchResultExpanded(properties: SearchResultExpandedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "9BNUma5en", name: "Context", value: properties.context});
  eventPropertiesArray.push({id: "Gvu_40yW7", name: "Search Rank", value: properties.searchRank});
  eventPropertiesArray.push({id: "psOVldb0Z", name: "Search Filter Option Selected", value: properties.searchFilterOptionSelected});
  eventPropertiesArray.push({id: "ssKpAufWU", name: "Search Result Count", value: properties.searchResultCount});
  eventPropertiesArray.push({id: "weaA0iE9I", name: "Search Result Type", value: properties.searchResultType});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eP2lOQQj8C", "0e4a15c99f4cfe0d756004f3127801a5eaefd7a789a782516d6221513dfe49f6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Result Expanded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eP2lOQQj8C", "Search Result Expanded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Result Expanded", eventProperties, "eP2lOQQj8C", "0e4a15c99f4cfe0d756004f3127801a5eaefd7a789a782516d6221513dfe49f6");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Result Expanded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonCompletedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
}
/**
 * Lesson Completed: When a pupil completes all the activities in a lesson during the pupil experience.
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Hy-6QNrYKU}
 */
export function lessonCompleted(properties: LessonCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Hy-6QNrYKU", "93997c5e38c723ce422a9db401067a5304a88f018c6ecb37ef4f037de128c3a4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Hy-6QNrYKU", "Lesson Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Completed", eventProperties, "Hy-6QNrYKU", "93997c5e38c723ce422a9db401067a5304a88f018c6ecb37ef4f037de128c3a4");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson 
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/sBllxa-nuz}
 */
export function lessonActivityCompleted(properties: LessonActivityCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz", "3d2904127705e3e64bd8d85b5805a2c0faafa68d1717b04746a03352fa020aad", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz", "3d2904127705e3e64bd8d85b5805a2c0faafa68d1717b04746a03352fa020aad");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedIntroductionProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson, variant description: An overview of the lesson and what the pupils expect to learn
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/sBllxa-nuz.w-tN4OqGk}
 */
export function lessonActivityCompletedIntroduction(properties: LessonActivityCompletedIntroductionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz.w-tN4OqGk", "5891b12515e69c3e6ed022e07193ecce4d8c69f6a54c63795e56e3e9a5b69cac", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz.w-tN4OqGk", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz.w-tN4OqGk", "5891b12515e69c3e6ed022e07193ecce4d8c69f6a54c63795e56e3e9a5b69cac");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedStarterQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilQuizGrade: number;
  hintQuestion: string;
  hintQuestionResult: string;
  hintUsed: string;
  pupilQuizNumQuestions: number;
  phase: PhaseValueType;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson, variant description: A quiz at the beginning of the lesson to understand their prior knowledge and prepare students for new content.
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.hintQuestion: The Question the hint was used on
 * @param properties.hintQuestionResult: Whether the pupil got the question right after using the hint
 * @param properties.hintUsed: Shows whether the pupil used the available hint
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/sBllxa-nuz.VPlVqR6yv}
 */
export function lessonActivityCompletedStarterQuiz(properties: LessonActivityCompletedStarterQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "7fVIgC0En", name: "Hint Question", value: properties.hintQuestion});
  eventPropertiesArray.push({id: "N42awt8Kz", name: "Hint Question Result", value: properties.hintQuestionResult});
  eventPropertiesArray.push({id: "mk7IFzd0V", name: "Hint Used", value: properties.hintUsed});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz.VPlVqR6yv", "b5b2f4f2bf42a20f3123b9ff94bd91ee6c329fbf7b1f64d79c1816850e1acdda", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz.VPlVqR6yv", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz.VPlVqR6yv", "b5b2f4f2bf42a20f3123b9ff94bd91ee6c329fbf7b1f64d79c1816850e1acdda");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedLessonVideoProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilVideoDurationSeconds: number;
  isMuted: boolean;
  signedOpened: boolean;
  videoTitle: string;
  numberOfVideos: number;
  pupilVideoTimeElapsedSeconds: number;
  videoSlug: string[];
  pupilVideoPlayed: boolean;
  videoPlaybackId: string[];
  isCaptioned: boolean;
  transcriptOpened: boolean;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson, variant description: A video that provides a visual and auditory explanation of the lesson's topic
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilVideoDurationSeconds: The total length of the video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.signedOpened: Indicates whether the sign language version of the content has been accessed/viewed
 * @param properties.videoTitle: Title of video
 * @param properties.numberOfVideos: The total count of videos available in a lesson
 * @param properties.pupilVideoTimeElapsedSeconds: The amount of time the pupil has spent watching the video in seconds
 * @param properties.videoSlug: Human-readable unique ID of the selected video.
 * @param properties.pupilVideoPlayed: True if the play button has been pressed at all during the session
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.transcriptOpened:  if the transcript of the video was accessed/viewed
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/sBllxa-nuz.66NwEPbGj}
 */
export function lessonActivityCompletedLessonVideo(properties: LessonActivityCompletedLessonVideoProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "4Ei7ce0ZP", name: "Pupil Video Duration (Seconds)", value: properties.pupilVideoDurationSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  eventPropertiesArray.push({id: "BDemZtV2_", name: "Signed Opened", value: properties.signedOpened});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "VDriy9qDh", name: "Number of Videos", value: properties.numberOfVideos});
  eventPropertiesArray.push({id: "cOQ8T6zw3", name: "Pupil Video Time Elapsed (Seconds)", value: properties.pupilVideoTimeElapsedSeconds});
  eventPropertiesArray.push({id: "gPpoyntqZe", name: "Video Slug", value: properties.videoSlug});
  eventPropertiesArray.push({id: "hmpQPI6sI", name: "Pupil Video Played", value: properties.pupilVideoPlayed});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "z6I3v88k_", name: "Transcript Opened", value: properties.transcriptOpened});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz.66NwEPbGj", "9d2b916110497a4334f92aea617147db49e7e02555c130654ec8d017fa2627ef", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz.66NwEPbGj", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz.66NwEPbGj", "9d2b916110497a4334f92aea617147db49e7e02555c130654ec8d017fa2627ef");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedExitQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilQuizGrade: number;
  hintQuestion: string;
  hintQuestionResult: string;
  hintUsed: string;
  pupilQuizNumQuestions: number;
  phase: PhaseValueType;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson, variant description: A quiz at the end of the lesson to assess students' understanding of the material covered.
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.hintQuestion: The Question the hint was used on
 * @param properties.hintQuestionResult: Whether the pupil got the question right after using the hint
 * @param properties.hintUsed: Shows whether the pupil used the available hint
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/sBllxa-nuz.pE7MH59gY}
 */
export function lessonActivityCompletedExitQuiz(properties: LessonActivityCompletedExitQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "7fVIgC0En", name: "Hint Question", value: properties.hintQuestion});
  eventPropertiesArray.push({id: "N42awt8Kz", name: "Hint Question Result", value: properties.hintQuestionResult});
  eventPropertiesArray.push({id: "mk7IFzd0V", name: "Hint Used", value: properties.hintUsed});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz.pE7MH59gY", "dbb15accec36ca6a65824c53ba8330a03efb7c1fee7245c7267a092e7e0ceb86", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz.pE7MH59gY", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz.pE7MH59gY", "dbb15accec36ca6a65824c53ba8330a03efb7c1fee7245c7267a092e7e0ceb86");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedLessonAudioProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilAudioPlayed: boolean;
  isMuted: boolean;
  signedOpened: boolean;
  pupilAudioTimeElapsedSeconds: string;
  numberOfAudios: string;
  audioPlaybackId: string;
  pupilAudioDurationSeconds: number;
  audioTitle: string;
  transcriptOpened: boolean;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson, variant description: A audio recording that provides a auditory explanation of the lesson's topic
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilAudioPlayed: True if the play button has been pressed at all during the activity
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.signedOpened: Indicates whether the sign language version of the content has been accessed/viewed
 * @param properties.pupilAudioTimeElapsedSeconds: The amount of time the pupil has spent listening to the audio in seconds
 * @param properties.numberOfAudios: The total count of audios available in a lesson
 * @param properties.audioPlaybackId: Playback Id of a audio
 * @param properties.pupilAudioDurationSeconds: The total length of the audio in seconds
 * @param properties.audioTitle: Title of Audio
 * @param properties.transcriptOpened:  if the transcript of the video was accessed/viewed
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/sBllxa-nuz.vftftUlwJ}
 */
export function lessonActivityCompletedLessonAudio(properties: LessonActivityCompletedLessonAudioProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "3dlfxTW-Q", name: "Pupil Audio Played", value: properties.pupilAudioPlayed});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  eventPropertiesArray.push({id: "BDemZtV2_", name: "Signed Opened", value: properties.signedOpened});
  eventPropertiesArray.push({id: "CZvLiY0yy", name: "Pupil Audio Time Elapsed (Seconds)", value: properties.pupilAudioTimeElapsedSeconds});
  eventPropertiesArray.push({id: "OZLuaJfBN", name: "Number of Audios", value: properties.numberOfAudios});
  eventPropertiesArray.push({id: "OeqPEmbLD", name: "Audio Playback Id", value: properties.audioPlaybackId});
  eventPropertiesArray.push({id: "vxfE3Mvtk", name: "Pupil Audio Duration (Seconds)", value: properties.pupilAudioDurationSeconds});
  eventPropertiesArray.push({id: "xYLviot7x", name: "Audio Title", value: properties.audioTitle});
  eventPropertiesArray.push({id: "z6I3v88k_", name: "Transcript Opened", value: properties.transcriptOpened});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz.vftftUlwJ", "669cbacc4563baa10b231be8de7d3d5c9e54116b0c4ebb8cb6574f7e5ac9f37b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz.vftftUlwJ", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz.vftftUlwJ", "669cbacc4563baa10b231be8de7d3d5c9e54116b0c4ebb8cb6574f7e5ac9f37b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonStartedProperties {
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  yearGroupName: string;
  yearGroupSlug: string;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
}
/**
 * Lesson Started: A student starts a new lesson, or a teacher views a lesson as a student.
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/9zz1OCsT2}
 */
export function lessonStarted(properties: LessonStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "9zz1OCsT2", "a900aae26780712fafb073caed04d48b7fd17513b49673487880b98f4f8d7841", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("9zz1OCsT2", "Lesson Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Started", eventProperties, "9zz1OCsT2", "a900aae26780712fafb073caed04d48b7fd17513b49673487880b98f4f8d7841");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/8LfOc60dl}
 */
export function lessonActivityStarted(properties: LessonActivityStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl", "bb5d232b875552fda7936e33b1f80456105e49002edeae21946e47b028d31790", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl", "bb5d232b875552fda7936e33b1f80456105e49002edeae21946e47b028d31790");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedIntroductionProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time, variant description: An overview of the lesson and what the pupils expect to learn
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/8LfOc60dl.sQj7v3rhg}
 */
export function lessonActivityStartedIntroduction(properties: LessonActivityStartedIntroductionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl.sQj7v3rhg", "ff4c1076fdeef717cb47b0b732eefc0c8b37fac44f06013cc0219a89fcd05e11", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl.sQj7v3rhg", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl.sQj7v3rhg", "ff4c1076fdeef717cb47b0b732eefc0c8b37fac44f06013cc0219a89fcd05e11");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedStarterQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  releaseGroup: string;
  hintAvailable: boolean;
  pupilQuizGrade: number;
  pupilQuizNumQuestions: number;
  phase: PhaseValueType;
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time, variant description: A quiz at the beginning of the lesson to understand their prior knowledge and prepare students for new content
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.hintAvailable: if a hint is provided for quiz question
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/8LfOc60dl.jXPPatapH}
 */
export function lessonActivityStartedStarterQuiz(properties: LessonActivityStartedStarterQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "0dn7bZTfJ", name: "Hint Available", value: properties.hintAvailable});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl.jXPPatapH", "69328298544e6e948965197f6363f1dd86cfeb530a3bcff20660445f21b62f84", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl.jXPPatapH", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl.jXPPatapH", "69328298544e6e948965197f6363f1dd86cfeb530a3bcff20660445f21b62f84");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedLessonVideoProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  pupilVideoDurationSeconds: number;
  signedAvailable: boolean;
  videoTitle: string;
  numberOfVideos: number;
  videoSlug: string[];
  pupilVideoPlayed: boolean;
  videoPlaybackId: string[];
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time, variant description: A video that provides a visual and auditory explanation of the lesson's topic
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.pupilVideoDurationSeconds: The total length of the video in seconds
 * @param properties.signedAvailable:  Indicates whether a sign language version of the content is available
 * @param properties.videoTitle: Title of video
 * @param properties.numberOfVideos: The total count of videos available in a lesson
 * @param properties.videoSlug: Human-readable unique ID of the selected video.
 * @param properties.pupilVideoPlayed: True if the play button has been pressed at all during the session
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/8LfOc60dl.--Q2qdv1R}
 */
export function lessonActivityStartedLessonVideo(properties: LessonActivityStartedLessonVideoProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "4Ei7ce0ZP", name: "Pupil Video Duration (Seconds)", value: properties.pupilVideoDurationSeconds});
  eventPropertiesArray.push({id: "JgWtPxquw", name: "Signed Available ", value: properties.signedAvailable});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "VDriy9qDh", name: "Number of Videos", value: properties.numberOfVideos});
  eventPropertiesArray.push({id: "gPpoyntqZe", name: "Video Slug", value: properties.videoSlug});
  eventPropertiesArray.push({id: "hmpQPI6sI", name: "Pupil Video Played", value: properties.pupilVideoPlayed});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl.--Q2qdv1R", "6a61b6612c5651aa774656e6e097c6f77b81199a6a5bb619325324e840f13156", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl.--Q2qdv1R", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl.--Q2qdv1R", "6a61b6612c5651aa774656e6e097c6f77b81199a6a5bb619325324e840f13156");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedExitQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  releaseGroup: string;
  hintAvailable: boolean;
  pupilQuizGrade: number;
  pupilQuizNumQuestions: number;
  phase: PhaseValueType;
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time, variant description: A quiz at the end of the lesson to assess students' understanding of the material covered.
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.hintAvailable: if a hint is provided for quiz question
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/8LfOc60dl.bwLDlBvXo}
 */
export function lessonActivityStartedExitQuiz(properties: LessonActivityStartedExitQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "0dn7bZTfJ", name: "Hint Available", value: properties.hintAvailable});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl.bwLDlBvXo", "f2453d9d007f128d47d5632f74ae6775b1f4f32907f8effb7db22456a607e701", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl.bwLDlBvXo", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl.bwLDlBvXo", "f2453d9d007f128d47d5632f74ae6775b1f4f32907f8effb7db22456a607e701");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedLessonAudioProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  pupilAudioPlayed: boolean;
  signedAvailable: boolean;
  numberOfAudios: string;
  audioPlaybackId: string;
  pupilAudioDurationSeconds: number;
  audioTitle: string;
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time, variant description: A audio recording that provides a auditory explanation of the lesson's topic
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.pupilAudioPlayed: True if the play button has been pressed at all during the activity
 * @param properties.signedAvailable:  Indicates whether a sign language version of the content is available
 * @param properties.numberOfAudios: The total count of audios available in a lesson
 * @param properties.audioPlaybackId: Playback Id of a audio
 * @param properties.pupilAudioDurationSeconds: The total length of the audio in seconds
 * @param properties.audioTitle: Title of Audio
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/8LfOc60dl.UadcF0krG}
 */
export function lessonActivityStartedLessonAudio(properties: LessonActivityStartedLessonAudioProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "3dlfxTW-Q", name: "Pupil Audio Played", value: properties.pupilAudioPlayed});
  eventPropertiesArray.push({id: "JgWtPxquw", name: "Signed Available ", value: properties.signedAvailable});
  eventPropertiesArray.push({id: "OZLuaJfBN", name: "Number of Audios", value: properties.numberOfAudios});
  eventPropertiesArray.push({id: "OeqPEmbLD", name: "Audio Playback Id", value: properties.audioPlaybackId});
  eventPropertiesArray.push({id: "vxfE3Mvtk", name: "Pupil Audio Duration (Seconds)", value: properties.pupilAudioDurationSeconds});
  eventPropertiesArray.push({id: "xYLviot7x", name: "Audio Title", value: properties.audioTitle});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl.UadcF0krG", "5053342caf55a5d067ca1655f41ad26c99be09e6d16018f44814faab663f9255", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl.UadcF0krG", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl.UadcF0krG", "5053342caf55a5d067ca1655f41ad26c99be09e6d16018f44814faab663f9255");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumResourcesDownloadedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  emailSupplied: boolean;
  resourceType: ResourceTypeValueType[];
  schoolOption: SchoolOptionValueType;
  schoolUrn: string;
  schoolName: string;
  subjectTitle: string;
  phase: PhaseValueType;
}
/**
 * Curriculum Resources Downloaded: Curriculum Resources Downloaded: A user downloaded one or more resources for a curriculum - this can either be a curriculum plan or previously released curriculum content. 
 * 
 * When to trigger this event:
 * 1. User clicks on the 'download' button on the 'Downloads' tab to download a curriculum plan, resource type = 'curriculum_plan'
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/L7-HOgqfOB/trigger/jUQsfF-ITbWp_67NmYgz3
 * 2. User clicks on the 'Download PDF' button on the 'Previously Released Curricula' page - Resource Type = 'previously_released_curricula'
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/L7-HOgqfOB/trigger/8nxd5KGbX7Ulg8ZhUyiRB
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.emailSupplied: A user has signed up for updates on the downloads page
 * @param properties.resourceType: The lesson resources a teacher selected for download.
 * @param properties.schoolOption: The option the user has selected as their school (selected school, homeschool or not listed)
 * @param properties.schoolUrn: School URN linked to GIAS attributes, should match regex: ^\d{3}\-?\d{3,4}$
 * @param properties.schoolName: Name of the school chosen from the school picker
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/L7-HOgqfOB}
 */
export function curriculumResourcesDownloaded(properties: CurriculumResourcesDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "3wxlGffcE", name: "Email Supplied", value: properties.emailSupplied});
  eventPropertiesArray.push({id: "H_kc7WuVNP", name: "Resource Type", value: properties.resourceType});
  eventPropertiesArray.push({id: "CrzKvLBC3", name: "School Option", value: properties.schoolOption});
  eventPropertiesArray.push({id: "G1iO4wRoL5", name: "School URN", value: properties.schoolUrn});
  eventPropertiesArray.push({id: "54PPZ-gkS", name: "School Name", value: properties.schoolName});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "L7-HOgqfOB", "1b14db93b8aa859de611f86b4a05f08c76aaddc2156ae830944d6f8e8873fb81", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Resources Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("L7-HOgqfOB", "Curriculum Resources Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Resources Downloaded", eventProperties, "L7-HOgqfOB", "1b14db93b8aa859de611f86b4a05f08c76aaddc2156ae830944d6f8e8873fb81");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Resources Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/lucA3x3s4}
 */
export function lessonActivityAbandoned(properties: LessonActivityAbandonedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4", "315215a9d7d1e11bf65d5322adcbfdad4777b17e551e2add72abf6ac9ed356de", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4", "315215a9d7d1e11bf65d5322adcbfdad4777b17e551e2add72abf6ac9ed356de");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedStarterQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilQuizGrade: number;
  hintQuestion: string;
  hintQuestionResult: string;
  hintUsed: string;
  pupilQuizNumQuestions: number;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it, variant description: A quiz at the beginning of the lesson to understand their prior knowledge and prepare students for new content.
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.hintQuestion: The Question the hint was used on
 * @param properties.hintQuestionResult: Whether the pupil got the question right after using the hint
 * @param properties.hintUsed: Shows whether the pupil used the available hint
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/lucA3x3s4.RRbQMT3mC}
 */
export function lessonActivityAbandonedStarterQuiz(properties: LessonActivityAbandonedStarterQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "7fVIgC0En", name: "Hint Question", value: properties.hintQuestion});
  eventPropertiesArray.push({id: "N42awt8Kz", name: "Hint Question Result", value: properties.hintQuestionResult});
  eventPropertiesArray.push({id: "mk7IFzd0V", name: "Hint Used", value: properties.hintUsed});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4.RRbQMT3mC", "8f740b8d5d2586c639052970c7a2977b178ae4ad59121431db7408652315dfff", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4.RRbQMT3mC", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4.RRbQMT3mC", "8f740b8d5d2586c639052970c7a2977b178ae4ad59121431db7408652315dfff");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedIntroductionProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it, variant description: An overview of the lesson and what the pupils expect to learn
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/lucA3x3s4.lfCw2Vowr}
 */
export function lessonActivityAbandonedIntroduction(properties: LessonActivityAbandonedIntroductionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4.lfCw2Vowr", "398f0eb0f8e0654be057af2662d26b2ad1189a17309d439ca27f6ba2213d203a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4.lfCw2Vowr", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4.lfCw2Vowr", "398f0eb0f8e0654be057af2662d26b2ad1189a17309d439ca27f6ba2213d203a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedLessonVideoProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilVideoDurationSeconds: number;
  isMuted: boolean;
  signedOpened: boolean;
  videoTitle: string;
  numberOfVideos: number;
  pupilVideoTimeElapsedSeconds: number;
  videoSlug: string[];
  pupilVideoPlayed: boolean;
  videoPlaybackId: string[];
  isCaptioned: boolean;
  transcriptOpened: boolean;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it, variant description: A video that provides a visual and auditory explanation of the lesson's topic
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilVideoDurationSeconds: The total length of the video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.signedOpened: Indicates whether the sign language version of the content has been accessed/viewed
 * @param properties.videoTitle: Title of video
 * @param properties.numberOfVideos: The total count of videos available in a lesson
 * @param properties.pupilVideoTimeElapsedSeconds: The amount of time the pupil has spent watching the video in seconds
 * @param properties.videoSlug: Human-readable unique ID of the selected video.
 * @param properties.pupilVideoPlayed: True if the play button has been pressed at all during the session
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.transcriptOpened:  if the transcript of the video was accessed/viewed
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/lucA3x3s4.F-FcsZGOv}
 */
export function lessonActivityAbandonedLessonVideo(properties: LessonActivityAbandonedLessonVideoProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "4Ei7ce0ZP", name: "Pupil Video Duration (Seconds)", value: properties.pupilVideoDurationSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  eventPropertiesArray.push({id: "BDemZtV2_", name: "Signed Opened", value: properties.signedOpened});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "VDriy9qDh", name: "Number of Videos", value: properties.numberOfVideos});
  eventPropertiesArray.push({id: "cOQ8T6zw3", name: "Pupil Video Time Elapsed (Seconds)", value: properties.pupilVideoTimeElapsedSeconds});
  eventPropertiesArray.push({id: "gPpoyntqZe", name: "Video Slug", value: properties.videoSlug});
  eventPropertiesArray.push({id: "hmpQPI6sI", name: "Pupil Video Played", value: properties.pupilVideoPlayed});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "z6I3v88k_", name: "Transcript Opened", value: properties.transcriptOpened});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4.F-FcsZGOv", "33da03eb95c992ac6aebe68163c5d4b5ee48c4f354dfd68fc99bdb0155df55bb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4.F-FcsZGOv", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4.F-FcsZGOv", "33da03eb95c992ac6aebe68163c5d4b5ee48c4f354dfd68fc99bdb0155df55bb");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedExitQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilQuizGrade: number;
  hintQuestion: string;
  hintQuestionResult: string;
  hintUsed: string;
  pupilQuizNumQuestions: number;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it, variant description: A quiz at the end of the lesson to assess students' understanding of the material covered.
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.hintQuestion: The Question the hint was used on
 * @param properties.hintQuestionResult: Whether the pupil got the question right after using the hint
 * @param properties.hintUsed: Shows whether the pupil used the available hint
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/lucA3x3s4.67Vn1Fv8t}
 */
export function lessonActivityAbandonedExitQuiz(properties: LessonActivityAbandonedExitQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "7fVIgC0En", name: "Hint Question", value: properties.hintQuestion});
  eventPropertiesArray.push({id: "N42awt8Kz", name: "Hint Question Result", value: properties.hintQuestionResult});
  eventPropertiesArray.push({id: "mk7IFzd0V", name: "Hint Used", value: properties.hintUsed});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4.67Vn1Fv8t", "dd864878164e7a7246f117af7806cec4a65790163255b536ac521624aade486e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4.67Vn1Fv8t", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4.67Vn1Fv8t", "dd864878164e7a7246f117af7806cec4a65790163255b536ac521624aade486e");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedLessonAudioProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilAudioPlayed: boolean;
  isMuted: boolean;
  signedOpened: boolean;
  pupilAudioTimeElapsedSeconds: string;
  numberOfAudios: string;
  audioPlaybackId: string;
  pupilAudioDurationSeconds: number;
  isCaptioned: boolean;
  audioTitle: string;
  transcriptOpened: boolean;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it, variant description: A audio recording that provides a auditory explanation of the lesson's topic
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilAudioPlayed: True if the play button has been pressed at all during the activity
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.signedOpened: Indicates whether the sign language version of the content has been accessed/viewed
 * @param properties.pupilAudioTimeElapsedSeconds: The amount of time the pupil has spent listening to the audio in seconds
 * @param properties.numberOfAudios: The total count of audios available in a lesson
 * @param properties.audioPlaybackId: Playback Id of a audio
 * @param properties.pupilAudioDurationSeconds: The total length of the audio in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.audioTitle: Title of Audio
 * @param properties.transcriptOpened:  if the transcript of the video was accessed/viewed
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/lucA3x3s4.6YVHZaiT6}
 */
export function lessonActivityAbandonedLessonAudio(properties: LessonActivityAbandonedLessonAudioProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "3dlfxTW-Q", name: "Pupil Audio Played", value: properties.pupilAudioPlayed});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  eventPropertiesArray.push({id: "BDemZtV2_", name: "Signed Opened", value: properties.signedOpened});
  eventPropertiesArray.push({id: "CZvLiY0yy", name: "Pupil Audio Time Elapsed (Seconds)", value: properties.pupilAudioTimeElapsedSeconds});
  eventPropertiesArray.push({id: "OZLuaJfBN", name: "Number of Audios", value: properties.numberOfAudios});
  eventPropertiesArray.push({id: "OeqPEmbLD", name: "Audio Playback Id", value: properties.audioPlaybackId});
  eventPropertiesArray.push({id: "vxfE3Mvtk", name: "Pupil Audio Duration (Seconds)", value: properties.pupilAudioDurationSeconds});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "xYLviot7x", name: "Audio Title", value: properties.audioTitle});
  eventPropertiesArray.push({id: "z6I3v88k_", name: "Transcript Opened", value: properties.transcriptOpened});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4.6YVHZaiT6", "e12f12134ebb5a9eddca3370920175d79a9a7d78b109f8f259f4112e6b29b6c7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4.6YVHZaiT6", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4.6YVHZaiT6", "e12f12134ebb5a9eddca3370920175d79a9a7d78b109f8f259f4112e6b29b6c7");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonAssistantAccessedProperties {
  isLoggedIn: boolean;
  componentType: ComponentTypeValueType;
  product: ProductValueType;
}
/**
 * Lesson Assistant Accessed: A user accesses the AI Lesson Assistant by clicking on the ‘Create a lesson’ button.
 * 
 * When to trigger this event:
 * 1. The user selects the Lesson Planner from the footer menu on the labs homepage
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/xsOZT-77ro/trigger/DLeioZeJ8
 * 2. User clicks on the 'Get started' button from the search results
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/xsOZT-77ro/trigger/LCMU0NPnivcZrJQ58uvzN
 * 
 * @param properties the properties associatied with this event
 * @param properties.isLoggedIn: Flags whether the user logged in or not before accessing the Oak object 
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/xsOZT-77ro}
 */
export function lessonAssistantAccessed(properties: LessonAssistantAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "p56ECmuX6", name: "Is Logged In", value: properties.isLoggedIn});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "xsOZT-77ro", "5ab48fbf6389379b8f26728ee88b2e3d43ff30e936e70670267d1348d53a30c0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Assistant Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("xsOZT-77ro", "Lesson Assistant Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Assistant Accessed", eventProperties, "xsOZT-77ro", "5ab48fbf6389379b8f26728ee88b2e3d43ff30e936e70670267d1348d53a30c0");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Assistant Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
}
/**
 * Lesson Accessed: Replaces the previous "Lesson Selected" event. Describes a user visiting a lesson in either the Teacher or Pupil Experience, typically at the end of a search or browse journey.
 * 
 * When to trigger this event:
 * 1. Lesson Page is loaded in the Pupil Experience
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/u21IHcK8_t/trigger/8mS2FLJSv
 * 2. Lesson Page is loaded in the Teacher Experience
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/u21IHcK8_t/trigger/MU1FQL9Lp
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/u21IHcK8_t}
 */
export function lessonAccessed(properties: LessonAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "u21IHcK8_t", "038a7fb0895cbd764117e3f55a20c20b56b6b782cb018941d9664bb836499e4f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("u21IHcK8_t", "Lesson Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Accessed", eventProperties, "u21IHcK8_t", "038a7fb0895cbd764117e3f55a20c20b56b6b782cb018941d9664bb836499e4f");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BrowseRefinedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  filterType: FilterTypeValueType;
  filterValue: string;
  activeFilters: ActiveFilters;
}
/**
 * Browse Refined: A step on the Browse Journey is completed "refining" the selection of units/lessons the user is interested in seeing.
 * 
 * When to trigger this event:
 * 1. An example from the Teacher Experience. Clicking on a Key Stage or a Subject would be an example of a refinement
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/qqX_ISnl2q/trigger/JfZk0CQKk
 * 2. An example from the Pupil Experience. Selecting a subject would class as a refinement
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/qqX_ISnl2q/trigger/4yqBipPtJ
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.filterType: Describes the dimension the filter is designed to control such as subject, key stage, or resource type
 * @param properties.filterValue: The value added to the filter (e.g. 'English' or 'AQA'). In the case where multiple filters are chosen simultaneously (e.g. Exam board and Tier) then both values should be sent separated by ', ' (e.g. 'AQA, Higher')
 * @param properties.activeFilters: The filters that are active at the time of the refinement event. Small json object in the form

```json
{
  'key_stage': [...key_stage_titles],
  'exam_board': […exam_board_titles],
  'subjects': […subject_titles],
  'content_types': […content_type] // should be one of ['units', 'lessons'] for now
}
```

Only include keys/values for active filters.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/qqX_ISnl2q}
 */
export function browseRefined(properties: BrowseRefinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "XPABjlx_F", name: "Filter Type", value: properties.filterType});
  eventPropertiesArray.push({id: "v3Ne3qUXs", name: "Filter Value", value: properties.filterValue});
  eventPropertiesArray.push({id: "TsVyKpbQ6", name: "Active Filters", value: properties.activeFilters});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qqX_ISnl2q", "12418d79946c4a575df6f92c3f634881aea136c62ccb1ed5b47f8f17d7f4567d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Browse Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qqX_ISnl2q", "Browse Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Browse Refined", eventProperties, "qqX_ISnl2q", "12418d79946c4a575df6f92c3f634881aea136c62ccb1ed5b47f8f17d7f4567d");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Browse Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BrowseRefinedAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  filterType: FilterTypeValueType;
  filterValue: string;
  activeFilters: ActiveFilters;
}
/**
 * Browse Refined: A step on the Browse Journey is completed "refining" the selection of units/lessons the user is interested in seeing., variant description: A special type of refinement that is the "first" step on a browse journey.
 * 
 * When to trigger this event:
 * 1. In the current iteration of the pupil experience the Accessed event will always be a year-group selection
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/qqX_ISnl2q.oU4o61r0g/trigger/yqG1kLnrT
 * 2. In the teacher experience the first browse event will always be through a key stage
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/qqX_ISnl2q.oU4o61r0g/trigger/jjG0aRtDl
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.filterType: Describes the dimension the filter is designed to control such as subject, key stage, or resource type
 * @param properties.filterValue: The value added to the filter (e.g. 'English' or 'AQA'). In the case where multiple filters are chosen simultaneously (e.g. Exam board and Tier) then both values should be sent separated by ', ' (e.g. 'AQA, Higher')
 * @param properties.activeFilters: The filters that are active at the time of the refinement event. Small json object in the form

```json
{
  'key_stage': [...key_stage_titles],
  'exam_board': […exam_board_titles],
  'subjects': […subject_titles],
  'content_types': […content_type] // should be one of ['units', 'lessons'] for now
}
```

Only include keys/values for active filters.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/qqX_ISnl2q.oU4o61r0g}
 */
export function browseRefinedAccessed(properties: BrowseRefinedAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "XPABjlx_F", name: "Filter Type", value: properties.filterType});
  eventPropertiesArray.push({id: "v3Ne3qUXs", name: "Filter Value", value: properties.filterValue});
  eventPropertiesArray.push({id: "TsVyKpbQ6", name: "Active Filters", value: properties.activeFilters});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qqX_ISnl2q.oU4o61r0g", "9f22949f051914f150cbc1f6aa8b95d5706bf1426526e44933751dbd3e7be015", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Browse Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qqX_ISnl2q.oU4o61r0g", "Browse Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Browse Refined", eventProperties, "qqX_ISnl2q.oU4o61r0g", "9f22949f051914f150cbc1f6aa8b95d5706bf1426526e44933751dbd3e7be015");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Browse Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityDownloadedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  phase: PhaseValueType;
  releaseGroup: string;
}
/**
 * Lesson Activity Downloaded: Event sent when a pupil has downloaded a lesson activity having clicked the download icon
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/reCapRsfgU/trigger/7ch5HthPl
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/reCapRsfgU}
 */
export function lessonActivityDownloaded(properties: LessonActivityDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "reCapRsfgU", "19c57e2ccf75003425dfc28933cb9f1baa4fa265af1913b96d9ef221ab57f4c7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("reCapRsfgU", "Lesson Activity Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Downloaded", eventProperties, "reCapRsfgU", "19c57e2ccf75003425dfc28933cb9f1baa4fa265af1913b96d9ef221ab57f4c7");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityDownloadedWorksheetProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  phase: PhaseValueType;
  releaseGroup: string;
}
/**
 * Lesson Activity Downloaded: Event sent when a pupil has downloaded a lesson activity having clicked the download icon, event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/reCapRsfgU.1gaZkUNtF}
 */
export function lessonActivityDownloadedWorksheet(properties: LessonActivityDownloadedWorksheetProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "reCapRsfgU.1gaZkUNtF", "16702baca4b09611efa90dd589b2542010caeb16a1f05f2d6c53b78efa9317d9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("reCapRsfgU.1gaZkUNtF", "Lesson Activity Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Downloaded", eventProperties, "reCapRsfgU.1gaZkUNtF", "16702baca4b09611efa90dd589b2542010caeb16a1f05f2d6c53b78efa9317d9");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ContentGuidanceAcceptedProperties {
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  phase: PhaseValueType;
  supervisionLevel: string;
  contentGuidanceWarning: ContentGuidanceWarningValueType;
  ageRestriction: string;
  ageRestriction: string;
}
/**
 * Content Guidance Accepted: Event sent when a pupil clicks to accept content guidance, indicating a choice to follow guidance and continues the lesson activity as a result 
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.supervisionLevel: The degree of adult oversight needed during a lesson
 * @param properties.contentGuidanceWarning: The category of the specific content guidance
 * @param properties.ageRestriction: no description
 * @param properties.ageRestriction: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/1u1gDPFXp3}
 */
export function contentGuidanceAccepted(properties: ContentGuidanceAcceptedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "AbSwsn_Lc", name: "Supervision Level", value: properties.supervisionLevel});
  eventPropertiesArray.push({id: "S-dilt6HW", name: "Content Guidance Warning", value: properties.contentGuidanceWarning});
  eventPropertiesArray.push({id: "vm0Wom_GiBfyytOkO_bp9", name: "Age Restriction", value: properties.ageRestriction});
  eventPropertiesArray.push({id: "CF6Y0mOU-_HgShZbz32dP", name: "Age Restriction", value: properties.ageRestriction});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1u1gDPFXp3", "f955a013475c2672a6deca277a34daedd67aff02e7a67d97408b3a0938ccc255", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Content Guidance Accepted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1u1gDPFXp3", "Content Guidance Accepted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Content Guidance Accepted", eventProperties, "1u1gDPFXp3", "f955a013475c2672a6deca277a34daedd67aff02e7a67d97408b3a0938ccc255");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Content Guidance Accepted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ContentGuidanceDeclinedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  supervisionLevel: string;
  phase: PhaseValueType;
  contentGuidanceWarning: ContentGuidanceWarningValueType;
  ageRestriction: string;
  ageRestriction: string;
}
/**
 * Content Guidance Declined: Event sent when a pupil clicks to decline content guidance, indicating a choice to not follow guidance and discontinues the lesson activity as a result 
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.supervisionLevel: The degree of adult oversight needed during a lesson
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.contentGuidanceWarning: The category of the specific content guidance
 * @param properties.ageRestriction: no description
 * @param properties.ageRestriction: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/2spbwH8iKS}
 */
export function contentGuidanceDeclined(properties: ContentGuidanceDeclinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "AbSwsn_Lc", name: "Supervision Level", value: properties.supervisionLevel});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "S-dilt6HW", name: "Content Guidance Warning", value: properties.contentGuidanceWarning});
  eventPropertiesArray.push({id: "vm0Wom_GiBfyytOkO_bp9", name: "Age Restriction", value: properties.ageRestriction});
  eventPropertiesArray.push({id: "CF6Y0mOU-_HgShZbz32dP", name: "Age Restriction", value: properties.ageRestriction});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2spbwH8iKS", "b0ec7efe9ce4521bbb5e3cc7d17f912d5392e3a1d2abcd22af108a270112a08b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Content Guidance Declined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2spbwH8iKS", "Content Guidance Declined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Content Guidance Declined", eventProperties, "2spbwH8iKS", "b0ec7efe9ce4521bbb5e3cc7d17f912d5392e3a1d2abcd22af108a270112a08b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Content Guidance Declined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ActivityResultsSharedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  yearGroupName: string;
  yearGroupSlug: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  phase: PhaseValueType;
  shareMedium: ShareMediumValueType;
  pupilExitQuizGrade: number | null | undefined;
  pupilStarterQuizGrade: number | null | undefined;
  pupilExitQuizNumQuestions: number | null | undefined;
  pupilStarterQuizNumQuesions: number | null | undefined;
  pupilExitQuiz: PupilExitQuiz[] | null | undefined;
  pupilStarterQuiz: PupilStarterQuiz[] | null | undefined;
}
/**
 * Activity Results Shared: Event sent when results of an lesson activity are shared by the pupil which results in visibility for the activity's results by a teacher
 * 
 * @param properties the properties associatied with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.shareMedium: The medium through which a link to a resource is shared
 * @param properties.pupilExitQuizGrade: Exit quiz results
 * @param properties.pupilStarterQuizGrade: Starter quiz grade
 * @param properties.pupilExitQuizNumQuestions: Number of questions in the exit quiz
 * @param properties.pupilStarterQuizNumQuesions: Number of questions in the starter quiz
 * @param properties.pupilExitQuiz: no description
 * @param properties.pupilStarterQuiz: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/IEzudJUnh0}
 */
export function activityResultsShared(properties: ActivityResultsSharedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "aMDyFQBYq", name: "Share Medium", value: properties.shareMedium});
  properties.pupilExitQuizGrade !== undefined && properties.pupilExitQuizGrade !== null ?
    eventPropertiesArray.push({id: "kKResr6NX", name: "Pupil Exit Quiz Grade", value: properties.pupilExitQuizGrade}) :
    eventPropertiesArray.push({id: "kKResr6NX", name: "Pupil Exit Quiz Grade", value: null});
  properties.pupilStarterQuizGrade !== undefined && properties.pupilStarterQuizGrade !== null ?
    eventPropertiesArray.push({id: "Ic-9YBoqQ", name: "Pupil Starter Quiz Grade", value: properties.pupilStarterQuizGrade}) :
    eventPropertiesArray.push({id: "Ic-9YBoqQ", name: "Pupil Starter Quiz Grade", value: null});
  properties.pupilExitQuizNumQuestions !== undefined && properties.pupilExitQuizNumQuestions !== null ?
    eventPropertiesArray.push({id: "DmB2Yp30-", name: "Pupil Exit Quiz Num Questions", value: properties.pupilExitQuizNumQuestions}) :
    eventPropertiesArray.push({id: "DmB2Yp30-", name: "Pupil Exit Quiz Num Questions", value: null});
  properties.pupilStarterQuizNumQuesions !== undefined && properties.pupilStarterQuizNumQuesions !== null ?
    eventPropertiesArray.push({id: "xgYuO9ij1", name: "Pupil Starter Quiz Num Quesions", value: properties.pupilStarterQuizNumQuesions}) :
    eventPropertiesArray.push({id: "xgYuO9ij1", name: "Pupil Starter Quiz Num Quesions", value: null});
  properties.pupilExitQuiz !== undefined && properties.pupilExitQuiz !== null ?
    eventPropertiesArray.push({id: "BvJKWCkFc", name: "Pupil Exit Quiz", value: properties.pupilExitQuiz.map(function(value) { return {
        "Question Result": value.questionResult,
        "Question Type": value.questionType,
        "Hint Offered": value.hintOffered,
        "Hint Accessed": value.hintAccessed,
        "Pupil Experience Lesson Activity": value.pupilExperienceLessonActivity,
        "Question Number": value.questionNumber,
      }
    })}) :
    eventPropertiesArray.push({id: "BvJKWCkFc", name: "Pupil Exit Quiz", value: null});
  properties.pupilStarterQuiz !== undefined && properties.pupilStarterQuiz !== null ?
    eventPropertiesArray.push({id: "GUtiqMHeN", name: "Pupil Starter Quiz", value: properties.pupilStarterQuiz.map(function(value) { return {
        "Pupil Experience Lesson Activity": value.pupilExperienceLessonActivity,
        "Question Type": value.questionType,
        "Question Result": value.questionResult,
        "Hint Offered": value.hintOffered,
        "Hint Accessed": value.hintAccessed,
        "Question Number": value.questionNumber,
      }
    })}) :
    eventPropertiesArray.push({id: "GUtiqMHeN", name: "Pupil Starter Quiz", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPupilExitQuizOptional(properties.pupilExitQuiz));
    messages = messages.concat(assertPupilStarterQuizOptional(properties.pupilStarterQuiz));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "IEzudJUnh0", "193cb75b41069c1b1958e827791823ab74b884ea6b6dbbca4b4ef273361b3af8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Activity Results Shared", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("IEzudJUnh0", "Activity Results Shared", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Activity Results Shared': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Activity Results Shared", eventProperties, "IEzudJUnh0", "193cb75b41069c1b1958e827791823ab74b884ea6b6dbbca4b4ef273361b3af8");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Activity Results Shared", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonSummaryReviewedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  pupilWorksheetAvailable: boolean;
  pupilWorksheetDownloaded: boolean;
  pupilExitQuizGrade: number | null | undefined;
  pupilStarterQuizGrade: number | null | undefined;
  pupilExitQuizNumQuestions: number | null | undefined;
  pupilStarterQuizNumQuesions: number | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  phase: PhaseValueType;
  pupilVideoPlayed: boolean;
  pupilVideoDurationSeconds: number | null | undefined;
  pupilVideoTimeElapsedSeconds: number | null | undefined;
  pupilExitQuiz: PupilExitQuiz[] | null | undefined;
  pupilStarterQuiz: PupilStarterQuiz[] | null | undefined;
}
/**
 * Lesson Summary Reviewed: Event sent when a pupil clicks to review the lesson summary after completing a lesson
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.pupilWorksheetAvailable: if a worksheet is provided as a activity for the lesson
 * @param properties.pupilWorksheetDownloaded: Indicates whether the pupil has downloaded the worksheet
 * @param properties.pupilExitQuizGrade: Exit quiz results
 * @param properties.pupilStarterQuizGrade: Starter quiz grade
 * @param properties.pupilExitQuizNumQuestions: Number of questions in the exit quiz
 * @param properties.pupilStarterQuizNumQuesions: Number of questions in the starter quiz
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.pupilVideoPlayed: True if the play button has been pressed at all during the session
 * @param properties.pupilVideoDurationSeconds: The total length of the video in seconds
 * @param properties.pupilVideoTimeElapsedSeconds: The amount of time the pupil has spent watching the video in seconds
 * @param properties.pupilExitQuiz: no description
 * @param properties.pupilStarterQuiz: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/HO-MSD-SiA}
 */
export function lessonSummaryReviewed(properties: LessonSummaryReviewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "rNM1I8vY_", name: "Pupil Worksheet Available", value: properties.pupilWorksheetAvailable});
  eventPropertiesArray.push({id: "AbY2tLMm3", name: "Pupil Worksheet Downloaded", value: properties.pupilWorksheetDownloaded});
  properties.pupilExitQuizGrade !== undefined && properties.pupilExitQuizGrade !== null ?
    eventPropertiesArray.push({id: "kKResr6NX", name: "Pupil Exit Quiz Grade", value: properties.pupilExitQuizGrade}) :
    eventPropertiesArray.push({id: "kKResr6NX", name: "Pupil Exit Quiz Grade", value: null});
  properties.pupilStarterQuizGrade !== undefined && properties.pupilStarterQuizGrade !== null ?
    eventPropertiesArray.push({id: "Ic-9YBoqQ", name: "Pupil Starter Quiz Grade", value: properties.pupilStarterQuizGrade}) :
    eventPropertiesArray.push({id: "Ic-9YBoqQ", name: "Pupil Starter Quiz Grade", value: null});
  properties.pupilExitQuizNumQuestions !== undefined && properties.pupilExitQuizNumQuestions !== null ?
    eventPropertiesArray.push({id: "DmB2Yp30-", name: "Pupil Exit Quiz Num Questions", value: properties.pupilExitQuizNumQuestions}) :
    eventPropertiesArray.push({id: "DmB2Yp30-", name: "Pupil Exit Quiz Num Questions", value: null});
  properties.pupilStarterQuizNumQuesions !== undefined && properties.pupilStarterQuizNumQuesions !== null ?
    eventPropertiesArray.push({id: "xgYuO9ij1", name: "Pupil Starter Quiz Num Quesions", value: properties.pupilStarterQuizNumQuesions}) :
    eventPropertiesArray.push({id: "xgYuO9ij1", name: "Pupil Starter Quiz Num Quesions", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "hmpQPI6sI", name: "Pupil Video Played", value: properties.pupilVideoPlayed});
  properties.pupilVideoDurationSeconds !== undefined && properties.pupilVideoDurationSeconds !== null ?
    eventPropertiesArray.push({id: "4Ei7ce0ZP", name: "Pupil Video Duration (Seconds)", value: properties.pupilVideoDurationSeconds}) :
    eventPropertiesArray.push({id: "4Ei7ce0ZP", name: "Pupil Video Duration (Seconds)", value: null});
  properties.pupilVideoTimeElapsedSeconds !== undefined && properties.pupilVideoTimeElapsedSeconds !== null ?
    eventPropertiesArray.push({id: "cOQ8T6zw3", name: "Pupil Video Time Elapsed (Seconds)", value: properties.pupilVideoTimeElapsedSeconds}) :
    eventPropertiesArray.push({id: "cOQ8T6zw3", name: "Pupil Video Time Elapsed (Seconds)", value: null});
  properties.pupilExitQuiz !== undefined && properties.pupilExitQuiz !== null ?
    eventPropertiesArray.push({id: "BvJKWCkFc", name: "Pupil Exit Quiz", value: properties.pupilExitQuiz.map(function(value) { return {
        "Question Result": value.questionResult,
        "Question Type": value.questionType,
        "Hint Offered": value.hintOffered,
        "Hint Accessed": value.hintAccessed,
        "Pupil Experience Lesson Activity": value.pupilExperienceLessonActivity,
        "Question Number": value.questionNumber,
      }
    })}) :
    eventPropertiesArray.push({id: "BvJKWCkFc", name: "Pupil Exit Quiz", value: null});
  properties.pupilStarterQuiz !== undefined && properties.pupilStarterQuiz !== null ?
    eventPropertiesArray.push({id: "GUtiqMHeN", name: "Pupil Starter Quiz", value: properties.pupilStarterQuiz.map(function(value) { return {
        "Pupil Experience Lesson Activity": value.pupilExperienceLessonActivity,
        "Question Type": value.questionType,
        "Question Result": value.questionResult,
        "Hint Offered": value.hintOffered,
        "Hint Accessed": value.hintAccessed,
        "Question Number": value.questionNumber,
      }
    })}) :
    eventPropertiesArray.push({id: "GUtiqMHeN", name: "Pupil Starter Quiz", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPupilExitQuizOptional(properties.pupilExitQuiz));
    messages = messages.concat(assertPupilStarterQuizOptional(properties.pupilStarterQuiz));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HO-MSD-SiA", "149a3b793a5c780a5822782de0499191b5d92d0cec6f0a0b0aef04a230cab87f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Summary Reviewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HO-MSD-SiA", "Lesson Summary Reviewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Lesson Summary Reviewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Summary Reviewed", eventProperties, "HO-MSD-SiA", "149a3b793a5c780a5822782de0499191b5d92d0cec6f0a0b0aef04a230cab87f");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Summary Reviewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserSignMinusUpCompletedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType | null | undefined;
  userId_: string;
  singleSignOnService: SingleSignOnServiceValueType;
}
/**
 * User Sign-Up Completed: A user creates a clerk account using SSO / email. At this point they are considerd to be "signed-up" and will go into the "onboarding" journey.

Platform: [owa, aila-beta]
Product: user account management
Engagement Intent: explore
Component Type: [see property description]
Event Version: 2.0.0
Analytics Use Case: N/A
 * 
 * When to trigger this event:
 * 1. A user uses SSO or email/password combination to create an account in Clerk.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/fOlHJypRwg/trigger/aV1XekNBLU
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.singleSignOnService: The Single Sign-On (SSO) Service used at a given stage of sign-up / sign-on.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/fOlHJypRwg}
 */
export function userSignUpCompleted(properties: UserSignMinusUpCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  properties.analyticsUseCase !== undefined && properties.analyticsUseCase !== null ?
    eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase}) :
    eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: null});
  eventPropertiesArray.push({id: "03PfePESj", name: "Single Sign-on Service", value: properties.singleSignOnService});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "fOlHJypRwg", "30172a6e41dfd3acad0e38729f8100e3e71f7f5e66734cab733b56cd9755b9c6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Sign-Up Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("fOlHJypRwg", "User Sign-Up Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Sign-Up Completed", eventProperties, "fOlHJypRwg", "30172a6e41dfd3acad0e38729f8100e3e71f7f5e66734cab733b56cd9755b9c6");
    }
    // destination PostHogEU
    PostHogEU.identify(properties.userId_);
    PostHogEU.logEvent("User Sign-Up Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserOnboardingCompletedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  userId_: string;
  signUpDate: string;
  userRoleType: UserRoleTypeValueType | null | undefined;
  teacherSchoolUrn: string | null | undefined;
  userDefinedRole: string | null | undefined;
  userDetailsLastModifiedDate: string;
  userAccountVerificationStatus: UserAccountVerificationStatusValueType;
  teacherSchoolManualEntryDetails: TeacherSchoolManualEntryDetails | null | undefined;
}
/**
 * User Onboarding Completed: The user completes the sign-up process for an account.

Platform: [owa, aila-beta]
Product: user account management
Engagement Intent: explore
Component Type: [see property description]
Event Version: 2.0.0
Analytics Use Case: N/A
 * 
 * When to trigger this event:
 * 1. A teacher user completes the final stage of the onboarding journey (either continue or skip) and onboarding is complete.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/1Wfnj8Bspf/trigger/rwg0-pla4a
 * 2. A non-teacher user completes the final stage of the onboarding journey and can be thought of as having completed the onboarding journey
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/1Wfnj8Bspf/trigger/mA2lAiF3la
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.signUpDate: The date a user signed-up for an account in YYYY-MM-DD format., should match regex: \d{4}-\d{2}-\d{2}
 * @param properties.userRoleType: The type of role the signed-in user holds. As defined when they sign-up or edit their details. This is used to differentiate between those with Teacher and Other types of Roles.
 * @param properties.teacherSchoolUrn: The Unique Reference Number (URN) of the school which a signed in user (or a user who has downloaded lesson resources) has provided. For English and Welsh Schools this is a 6 digit number, for Scottish Schools this is a 7 digit number (Seed number) and for NI Schools it is a 3 digit number followed by a four digit number., should match regex: ^\d{3}\-?\d{3,4}$
 * @param properties.userDefinedRole: Used in cases where the User Role Type is set to 'Other'. Free text which best describes a user's role
 * @param properties.userDetailsLastModifiedDate: The date on which a user last modified their details., should match regex: \d{4}-\d{2}-\d{2}
 * @param properties.userAccountVerificationStatus: The status of the user account
 * @param properties.teacherSchoolManualEntryDetails: A small object containing the manually entered details of a users school when it is not available in the school picker.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/1Wfnj8Bspf}
 */
export function userOnboardingCompleted(properties: UserOnboardingCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  userPropertiesArray.push({id: "gG_w27SKHB", name: "Sign-Up Date", value: properties.signUpDate});
  properties.userRoleType !== undefined && properties.userRoleType !== null ?
    userPropertiesArray.push({id: "UzbEhqXqIC", name: "User Role Type", value: properties.userRoleType}) :
    userPropertiesArray.push({id: "UzbEhqXqIC", name: "User Role Type", value: null});
  properties.teacherSchoolUrn !== undefined && properties.teacherSchoolUrn !== null ?
    userPropertiesArray.push({id: "BgFeT6JsIV", name: "Teacher School URN", value: properties.teacherSchoolUrn}) :
    userPropertiesArray.push({id: "BgFeT6JsIV", name: "Teacher School URN", value: null});
  properties.userDefinedRole !== undefined && properties.userDefinedRole !== null ?
    userPropertiesArray.push({id: "jveNRqbgzO", name: "User Defined Role", value: properties.userDefinedRole}) :
    userPropertiesArray.push({id: "jveNRqbgzO", name: "User Defined Role", value: null});
  userPropertiesArray.push({id: "Tnbcjv4vnh", name: "User Details Last Modified Date", value: properties.userDetailsLastModifiedDate});
  userPropertiesArray.push({id: "6LTMhPtr6", name: "User Account Verification Status", value: properties.userAccountVerificationStatus});
  properties.teacherSchoolManualEntryDetails !== undefined && properties.teacherSchoolManualEntryDetails !== null ?
    userPropertiesArray.push({id: "FqpH5gAYj", name: "Teacher School Manual Entry Details", value: {
      "School Name Text": properties.teacherSchoolManualEntryDetails.schoolNameText,
      "School Address Text": properties.teacherSchoolManualEntryDetails.schoolAddressText,
    }}) :
    userPropertiesArray.push({id: "FqpH5gAYj", name: "Teacher School Manual Entry Details", value: null});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertTeacherSchoolManualEntryDetailsOptional(properties.teacherSchoolManualEntryDetails));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1Wfnj8Bspf", "230a8dab8ff5b9945e80d186667d399477fac996ad88b0a0c3fe47654bd0a766", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Onboarding Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1Wfnj8Bspf", "User Onboarding Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'User Onboarding Completed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Onboarding Completed", eventProperties, "1Wfnj8Bspf", "230a8dab8ff5b9945e80d186667d399477fac996ad88b0a0c3fe47654bd0a766");
    }
    // destination PostHogEU
    PostHogEU.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    PostHogEU.logEvent("User Onboarding Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserSignMinusInProperties {
  userId_: string;
}
/**
 * User Sign-In: A user signs in to a pre-existing account
 * 
 * @param properties the properties associatied with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/KiDGLM5Isg}
 */
export function userSignIn(properties: UserSignMinusInProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KiDGLM5Isg", "8aa23f39ed39354945297f5ada68807d8d0b2a4d47ed9980b245d330b068eec0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Sign-In", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KiDGLM5Isg", "User Sign-In", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Sign-In", eventProperties, "KiDGLM5Isg", "8aa23f39ed39354945297f5ada68807d8d0b2a4d47ed9980b245d330b068eec0");
    }
    // destination PostHogEU
    PostHogEU.identify(properties.userId_);
    PostHogEU.logEvent("User Sign-In", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * User Sign-Out: A user signs-out of their account
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/j0lSWreaah}
 */
export function userSignOut() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "j0lSWreaah", "42616b156d70c13c23335f03d22bbc19c51f0ebb8a8b802d7e1a4792fee8d533", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Sign-Out", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("j0lSWreaah", "User Sign-Out", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Sign-Out", eventProperties, "j0lSWreaah", "42616b156d70c13c23335f03d22bbc19c51f0ebb8a8b802d7e1a4792fee8d533");
    }
    // destination PostHogEU
    PostHogEU.logEvent("User Sign-Out", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserOnboardingProgressedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  userId_: string;
  signUpDate: string | null | undefined;
  userRoleType: UserRoleTypeValueType | null | undefined;
  teacherSchoolUrn: string | null | undefined;
  userDefinedRole: string | null | undefined;
  userDetailsLastModifiedDate: string;
  userAccountVerificationStatus: UserAccountVerificationStatusValueType | null | undefined;
  teacherSchoolManualEntryDetails: TeacherSchoolManualEntryDetails | null | undefined;
}
/**
 * User Onboarding Progressed: The user progresses the onboarding process by completing one of theintermediate steps between completing sign-up (creating a Clerk account) and completing onboarding.
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.signUpDate: The date a user signed-up for an account in YYYY-MM-DD format., should match regex: \d{4}-\d{2}-\d{2}
 * @param properties.userRoleType: The type of role the signed-in user holds. As defined when they sign-up or edit their details. This is used to differentiate between those with Teacher and Other types of Roles.
 * @param properties.teacherSchoolUrn: The Unique Reference Number (URN) of the school which a signed in user (or a user who has downloaded lesson resources) has provided. For English and Welsh Schools this is a 6 digit number, for Scottish Schools this is a 7 digit number (Seed number) and for NI Schools it is a 3 digit number followed by a four digit number., should match regex: ^\d{3}\-?\d{3,4}$
 * @param properties.userDefinedRole: Used in cases where the User Role Type is set to 'Other'. Free text which best describes a user's role
 * @param properties.userDetailsLastModifiedDate: The date on which a user last modified their details., should match regex: \d{4}-\d{2}-\d{2}
 * @param properties.userAccountVerificationStatus: The status of the user account
 * @param properties.teacherSchoolManualEntryDetails: A small object containing the manually entered details of a users school when it is not available in the school picker.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/WFQ_xNUmm}
 */
export function userOnboardingProgressed(properties: UserOnboardingProgressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.signUpDate !== undefined && properties.signUpDate !== null ?
    userPropertiesArray.push({id: "gG_w27SKHB", name: "Sign-Up Date", value: properties.signUpDate}) :
    userPropertiesArray.push({id: "gG_w27SKHB", name: "Sign-Up Date", value: null});
  properties.userRoleType !== undefined && properties.userRoleType !== null ?
    userPropertiesArray.push({id: "UzbEhqXqIC", name: "User Role Type", value: properties.userRoleType}) :
    userPropertiesArray.push({id: "UzbEhqXqIC", name: "User Role Type", value: null});
  properties.teacherSchoolUrn !== undefined && properties.teacherSchoolUrn !== null ?
    userPropertiesArray.push({id: "BgFeT6JsIV", name: "Teacher School URN", value: properties.teacherSchoolUrn}) :
    userPropertiesArray.push({id: "BgFeT6JsIV", name: "Teacher School URN", value: null});
  properties.userDefinedRole !== undefined && properties.userDefinedRole !== null ?
    userPropertiesArray.push({id: "jveNRqbgzO", name: "User Defined Role", value: properties.userDefinedRole}) :
    userPropertiesArray.push({id: "jveNRqbgzO", name: "User Defined Role", value: null});
  userPropertiesArray.push({id: "Tnbcjv4vnh", name: "User Details Last Modified Date", value: properties.userDetailsLastModifiedDate});
  properties.userAccountVerificationStatus !== undefined && properties.userAccountVerificationStatus !== null ?
    userPropertiesArray.push({id: "6LTMhPtr6", name: "User Account Verification Status", value: properties.userAccountVerificationStatus}) :
    userPropertiesArray.push({id: "6LTMhPtr6", name: "User Account Verification Status", value: null});
  properties.teacherSchoolManualEntryDetails !== undefined && properties.teacherSchoolManualEntryDetails !== null ?
    userPropertiesArray.push({id: "FqpH5gAYj", name: "Teacher School Manual Entry Details", value: {
      "School Name Text": properties.teacherSchoolManualEntryDetails.schoolNameText,
      "School Address Text": properties.teacherSchoolManualEntryDetails.schoolAddressText,
    }}) :
    userPropertiesArray.push({id: "FqpH5gAYj", name: "Teacher School Manual Entry Details", value: null});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertTeacherSchoolManualEntryDetailsOptional(properties.teacherSchoolManualEntryDetails));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "WFQ_xNUmm", "2ff639be7637a742bc82d85832dd0f792c2826a02854ccd94feca5536b8160a3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Onboarding Progressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("WFQ_xNUmm", "User Onboarding Progressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'User Onboarding Progressed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    // destination PostHogEU
    PostHogEU.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
  } else {
    // do nothing
  }
}

export interface LessonAbandonedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  yearGroupName: string;
  yearGroupSlug: string;
  phase: PhaseValueType;
}
/**
 * Lesson Abandoned: Event sent when lesson is abandoned before completion
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/qv9EeULbT}
 */
export function lessonAbandoned(properties: LessonAbandonedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qv9EeULbT", "c92f32721a19d28fba843a1f08c1a0b0f820519e9c668d3d89465ec041c40a7a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qv9EeULbT", "Lesson Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Abandoned", eventProperties, "qv9EeULbT", "c92f32721a19d28fba843a1f08c1a0b0f820519e9c668d3d89465ec041c40a7a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BrowseAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Browse Accessed: The browse experience has been accessed
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/MFzroCdj0}
 */
export function browseAccessed(properties: BrowseAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MFzroCdj0", "cfb05c509d91ec26de6b73ac010dce9926e98b3c10834352b706387cdfde6f62", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Browse Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MFzroCdj0", "Browse Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Browse Accessed", eventProperties, "MFzroCdj0", "cfb05c509d91ec26de6b73ac010dce9926e98b3c10834352b706387cdfde6f62");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Browse Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface QuestionAttemptSubmittedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  questionResult: QuestionResultValueType;
  questionType: string;
  activityTimeSpent: number;
  hintOffered: boolean;
  hintAccessed: boolean;
  questionNumber: number;
}
/**
 * Question Attempt Submitted: Event sent everytime a quiz question is attempted
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.questionResult: whether or not the question was answered correctly
 * @param properties.questionType: no description
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.hintOffered: no description
 * @param properties.hintAccessed: no description
 * @param properties.questionNumber: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/oxHJDrfL0el}
 */
export function questionAttemptSubmitted(properties: QuestionAttemptSubmittedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "FNZnup8Lj", name: "Question Result", value: properties.questionResult});
  eventPropertiesArray.push({id: "fO393FGJA", name: "Question Type", value: properties.questionType});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "2Hdg058Fn", name: "Hint Offered", value: properties.hintOffered});
  eventPropertiesArray.push({id: "1nV6NwNSF", name: "Hint Accessed", value: properties.hintAccessed});
  eventPropertiesArray.push({id: "Ya3cRG6Q-", name: "Question Number", value: properties.questionNumber});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "oxHJDrfL0el", "c67789424f363046a1278243de5da6cfbed3de1335ee393c41662b674dfabf0f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Question Attempt Submitted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("oxHJDrfL0el", "Question Attempt Submitted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Question Attempt Submitted", eventProperties, "oxHJDrfL0el", "c67789424f363046a1278243de5da6cfbed3de1335ee393c41662b674dfabf0f");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Question Attempt Submitted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherShareInitiatedProperties {
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  shareId: string;
  sourcePageSlug: string | null | undefined;
}
/**
 * Teacher Share Initiated: On initial access of a page with a share with teacher button
 * 
 * @param properties the properties associatied with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.shareId: unique id associated with a share event
 * @param properties.sourcePageSlug: The slug portion of the url used to identify the page (on Oak's Website) from which an event was triggered. (e.g.  'teachers/curriculum/english-primary/units')
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/4zw48vJqLbd}
 */
export function teacherShareInitiated(properties: TeacherShareInitiatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: properties.shareId});
  properties.sourcePageSlug !== undefined && properties.sourcePageSlug !== null ?
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: properties.sourcePageSlug}) :
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4zw48vJqLbd", "08e678bd20e9eeb019d7b0b1dc86c3cefd42190e91cc81fb1aff71623c6ed7c3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Share Initiated", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4zw48vJqLbd", "Teacher Share Initiated", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Share Initiated", eventProperties, "4zw48vJqLbd", "08e678bd20e9eeb019d7b0b1dc86c3cefd42190e91cc81fb1aff71623c6ed7c3");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Share Initiated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherShareActivatedProperties {
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  sourcePageSlug: string | null | undefined;
  shareId: string;
  linkUrl: string;
  noteLengthChars: number | null | undefined;
}
/**
 * Teacher Share Activated: When a share is activated by pressing a button
 * 
 * @param properties the properties associatied with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.sourcePageSlug: The slug portion of the url used to identify the page (on Oak's Website) from which an event was triggered. (e.g.  'teachers/curriculum/english-primary/units')
 * @param properties.shareId: unique id associated with a share event
 * @param properties.linkUrl: The href of a link
 * @param properties.noteLengthChars: The character length of a teacher note
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/ttpIP3aUQX2}
 */
export function teacherShareActivated(properties: TeacherShareActivatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.sourcePageSlug !== undefined && properties.sourcePageSlug !== null ?
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: properties.sourcePageSlug}) :
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: null});
  eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: properties.shareId});
  eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl});
  properties.noteLengthChars !== undefined && properties.noteLengthChars !== null ?
    eventPropertiesArray.push({id: "O3iW9GlOX3vMEXtryknax", name: "Note Length Chars", value: properties.noteLengthChars}) :
    eventPropertiesArray.push({id: "O3iW9GlOX3vMEXtryknax", name: "Note Length Chars", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ttpIP3aUQX2", "e092f0e6516b99ffe98d32fcdb300957c787c9378e606234054f11f750758a68", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Share Activated", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ttpIP3aUQX2", "Teacher Share Activated", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Share Activated", eventProperties, "ttpIP3aUQX2", "e092f0e6516b99ffe98d32fcdb300957c787c9378e606234054f11f750758a68");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Share Activated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherShareConvertedProperties {
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  shareId: string;
  linkUrl: string;
}
/**
 * Teacher Share Converted: The first time another user accesses a share url
 * 
 * @param properties the properties associatied with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.shareId: unique id associated with a share event
 * @param properties.linkUrl: The href of a link
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/ANLiC7JLe7-}
 */
export function teacherShareConverted(properties: TeacherShareConvertedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: properties.shareId});
  eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ANLiC7JLe7-", "98ac18427bed5b92201c175e88801bce01040768a27269d1c9b9a524f30de00c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Share Converted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ANLiC7JLe7-", "Teacher Share Converted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Share Converted", eventProperties, "ANLiC7JLe7-", "98ac18427bed5b92201c175e88801bce01040768a27269d1c9b9a524f30de00c");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Share Converted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UnitDownloadInitiatedProperties {
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
}
/**
 * Unit Download Initiated: A user clicks the unit download button on a lesson listing page
 * 
 * @param properties the properties associatied with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/72bRke5-7b0}
 */
export function unitDownloadInitiated(properties: UnitDownloadInitiatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "72bRke5-7b0", "010d10aadf43cb97e4af44e33e08670b314cab669fd42f444d1a7f172eaf8826", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Unit Download Initiated", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("72bRke5-7b0", "Unit Download Initiated", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unit Download Initiated", eventProperties, "72bRke5-7b0", "010d10aadf43cb97e4af44e33e08670b314cab669fd42f444d1a7f172eaf8826");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Unit Download Initiated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherNoteDialogueOpenedProperties {
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  shareId: string | null | undefined;
  sourcePageSlug: string | null | undefined;
  linkUrl: string | null | undefined;
}
/**
 * Teacher Note Dialogue Opened: Sent every time the add / edit teacher note dialogue is opened on the lesson overview page
 * 
 * @param properties the properties associatied with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.shareId: unique id associated with a share event
 * @param properties.sourcePageSlug: The slug portion of the url used to identify the page (on Oak's Website) from which an event was triggered. (e.g.  'teachers/curriculum/english-primary/units')
 * @param properties.linkUrl: The href of a link
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/ZfGgVMk2GGv2hxZQMZDBl}
 */
export function teacherNoteDialogueOpened(properties: TeacherNoteDialogueOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.shareId !== undefined && properties.shareId !== null ?
    eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: properties.shareId}) :
    eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: null});
  properties.sourcePageSlug !== undefined && properties.sourcePageSlug !== null ?
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: properties.sourcePageSlug}) :
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: null});
  properties.linkUrl !== undefined && properties.linkUrl !== null ?
    eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl}) :
    eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ZfGgVMk2GGv2hxZQMZDBl", "c7746a24f8cdf01d289a00b56a45f9ace658f27733540d152c5bfb430cb91bb0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Note Dialogue Opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ZfGgVMk2GGv2hxZQMZDBl", "Teacher Note Dialogue Opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Note Dialogue Opened", eventProperties, "ZfGgVMk2GGv2hxZQMZDBl", "c7746a24f8cdf01d289a00b56a45f9ace658f27733540d152c5bfb430cb91bb0");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Note Dialogue Opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherNoteSavedProperties {
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  shareId: string;
  sourcePageSlug: string | null | undefined;
  linkUrl: string;
  noteLengthChars: number;
}
/**
 * Teacher Note Saved: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.shareId: unique id associated with a share event
 * @param properties.sourcePageSlug: The slug portion of the url used to identify the page (on Oak's Website) from which an event was triggered. (e.g.  'teachers/curriculum/english-primary/units')
 * @param properties.linkUrl: The href of a link
 * @param properties.noteLengthChars: The character length of a teacher note
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/rY3jUdERBSrdNUQPY_2h-}
 */
export function teacherNoteSaved(properties: TeacherNoteSavedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: properties.shareId});
  properties.sourcePageSlug !== undefined && properties.sourcePageSlug !== null ?
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: properties.sourcePageSlug}) :
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: null});
  eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl});
  eventPropertiesArray.push({id: "O3iW9GlOX3vMEXtryknax", name: "Note Length Chars", value: properties.noteLengthChars});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rY3jUdERBSrdNUQPY_2h-", "7dfeb18ffa68a0d19a9ab3dde93b90f9c80a8deaa3fa114fe1159a078bc86c61", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Note Saved", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rY3jUdERBSrdNUQPY_2h-", "Teacher Note Saved", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Note Saved", eventProperties, "rY3jUdERBSrdNUQPY_2h-", "7dfeb18ffa68a0d19a9ab3dde93b90f9c80a8deaa3fa114fe1159a078bc86c61");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Note Saved", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumVisualiserExitedProperties {
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  yearGroupName: string;
  yearGroupSlug: string;
}
/**
 * Curriculum Visualiser Exited: A user moves onto another product on the site and therefore leaves the Curriculum Visualiser. This is currently done by moving onto a Unit listing page from a unit Modal by clicking on ‘See lessons in unit’.
 * 
 * When to trigger this event:
 * 1. User clicks on 'See lessons in unit'
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/zsO3YXYKon/trigger/DevPKYouf
 * 
 * @param properties the properties associatied with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/zsO3YXYKon}
 */
export function curriculumVisualiserExited(properties: CurriculumVisualiserExitedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "zsO3YXYKon", "e92097946135fef8565a914856e90ed39c3edcf1607f0fed09bd98e5d29cc3cc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Visualiser Exited", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("zsO3YXYKon", "Curriculum Visualiser Exited", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Visualiser Exited", eventProperties, "zsO3YXYKon", "e92097946135fef8565a914856e90ed39c3edcf1607f0fed09bd98e5d29cc3cc");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Visualiser Exited", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumVisualiserTabAccessedProperties {
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
}
/**
 * Curriculum Visualiser Tab Accessed: The user clicks on one of the tabs displayed within the Curriculum Visualiser e.g. 'Unit Sequence', 'Explainer' or 'Download'
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/lyC0uySKzt/trigger/PcASRZWOw1ku51PJZc9CB
 * 2. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/lyC0uySKzt/trigger/D1VxROFKdnXDVTvFaw9Gs
 * 3. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/lyC0uySKzt/trigger/fgn-xU4Zxy0ZQxt_KOcnH
 * 
 * @param properties the properties associatied with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/lyC0uySKzt}
 */
export function curriculumVisualiserTabAccessed(properties: CurriculumVisualiserTabAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lyC0uySKzt", "438c4ee6549a292a6fc330206861fcb4d8e4e876a2b3a0f9a2636a30505c9a61", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Visualiser Tab Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lyC0uySKzt", "Curriculum Visualiser Tab Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Visualiser Tab Accessed", eventProperties, "lyC0uySKzt", "438c4ee6549a292a6fc330206861fcb4d8e4e876a2b3a0f9a2636a30505c9a61");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Visualiser Tab Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UnitOverviewExploredProperties {
  subjectTitle: string;
  subjectSlug: string;
  threadTitle: string;
  threadSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  unitName: string;
  unitSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Unit Overview Explored: The user interacts with a unit overview by clicking on one of the buttons on the pop out.
 * 
 * When to trigger this event:
 * 1. User clicks on one of the accordians within the unit overview pop out
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/i6-nnHEIYs/trigger/1eRpH5Gxy
 * 2. Depending on the unit, the accordian tab names will vary
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/i6-nnHEIYs/trigger/Iy1Mdcswp_HFz7gu3Vkv8
 * 
 * @param properties the properties associatied with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.threadTitle: The title (in plain English including spaces) of a thread corresponding to a sequence of lessons across units
 * @param properties.threadSlug: The human readable identifier (n-kebab-case) for a sequence of lessons
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/i6-nnHEIYs}
 */
export function unitOverviewExplored(properties: UnitOverviewExploredProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "5vqHiL5Sh", name: "Thread Title", value: properties.threadTitle});
  eventPropertiesArray.push({id: "E1mlACg_OT", name: "Thread Slug", value: properties.threadSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "i6-nnHEIYs", "fc0b9164b2e94c1b45169de897e08cd15fa6318ea19fa98a24e5c61771dd5794", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Unit Overview Explored", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("i6-nnHEIYs", "Unit Overview Explored", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unit Overview Explored", eventProperties, "i6-nnHEIYs", "fc0b9164b2e94c1b45169de897e08cd15fa6318ea19fa98a24e5c61771dd5794");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Unit Overview Explored", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductHomepageAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Product Homepage Accessed: A user selects one of Oak's products from the tabs available on the homepage e.g. Lesson Teaching Resources, Curriculum Plans, AI Experiments, Pupils
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Lftzxt-mHyPsAzsv5H2Vi/trigger/a85DGvpxPtzycSgl20lbY
 * 2. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Lftzxt-mHyPsAzsv5H2Vi/trigger/dWx1KqJ9Z1YDgC5lDOY94
 * 3. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Lftzxt-mHyPsAzsv5H2Vi/trigger/MMsrYL3JK596X0m5vVdWP
 * 4. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Lftzxt-mHyPsAzsv5H2Vi/trigger/Crn6BaMk17vcqoYOgaFs1
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Lftzxt-mHyPsAzsv5H2Vi}
 */
export function productHomepageAccessed(properties: ProductHomepageAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Lftzxt-mHyPsAzsv5H2Vi", "856ebedfaaba3a07dc237b88fb16dd91cf2fa8fcd629581ad920404b45d5386c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Homepage Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Lftzxt-mHyPsAzsv5H2Vi", "Product Homepage Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Homepage Accessed", eventProperties, "Lftzxt-mHyPsAzsv5H2Vi", "856ebedfaaba3a07dc237b88fb16dd91cf2fa8fcd629581ad920404b45d5386c");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Product Homepage Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumLandingPageAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Curriculum Landing Page Accessed: The user clicks on the 'Our curriculum planning approach' button on the Curriculum Plans tab of the Oak homepage.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Sv8oxJgYPLCidSo_wxLpN/trigger/6A2Ow5TjrtpMpDLy_gR_n
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/Sv8oxJgYPLCidSo_wxLpN}
 */
export function curriculumLandingPageAccessed(properties: CurriculumLandingPageAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Sv8oxJgYPLCidSo_wxLpN", "d7bf62a4e91fe627e5abed6e252f5ad51426263dac69d381a30d4cc062ffff88", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Landing Page Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Sv8oxJgYPLCidSo_wxLpN", "Curriculum Landing Page Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Landing Page Accessed", eventProperties, "Sv8oxJgYPLCidSo_wxLpN", "d7bf62a4e91fe627e5abed6e252f5ad51426263dac69d381a30d4cc062ffff88");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Landing Page Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumExplainerExploredProperties {
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
}
/**
 * Curriculum Explainer Explored: User navigates to any of the areas of the contents page within the Explainer tab of the Curriculum Visualiser
 * 
 * When to trigger this event:
 * 1. User navigates to any of the contents on the left
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/FP1B-pCMEjGG0k3hk6oXU/trigger/YgOtQr6ps2icWqT4X3JT7
 * 
 * @param properties the properties associatied with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/FP1B-pCMEjGG0k3hk6oXU}
 */
export function curriculumExplainerExplored(properties: CurriculumExplainerExploredProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "FP1B-pCMEjGG0k3hk6oXU", "e1a9a9d18511cf3dc4308c072b0669f4d86d9fb58ebd7ec0e7fabed74936afcf", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Explainer Explored", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("FP1B-pCMEjGG0k3hk6oXU", "Curriculum Explainer Explored", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Explainer Explored", eventProperties, "FP1B-pCMEjGG0k3hk6oXU", "e1a9a9d18511cf3dc4308c072b0669f4d86d9fb58ebd7ec0e7fabed74936afcf");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Explainer Explored", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumResourcesDownloadRefinedProperties {
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  childSubjectSlug: string;
  childSubjectName: string;
  learningTier: LearningTierValueType;
}
/**
 * Curriculum Resources Download Refined: For certain subjects/phasees, the user narrows down which subject/phase they wish to download curriculum resources for.
 * 
 * When to trigger this event:
 * 1. User selects a subject and learning tier to download curriculum resources for
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/cTKf4kbAHd211SR05Bbq8/trigger/j79s4AM_FvlH_6oP87NBj
 * 
 * @param properties the properties associatied with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.childSubjectSlug: Slug of Child Subject associated with the event
 * @param properties.childSubjectName: Name of the Child Subject Associated with the event
 * @param properties.learningTier: Learning tier that was selected
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/cTKf4kbAHd211SR05Bbq8}
 */
export function curriculumResourcesDownloadRefined(properties: CurriculumResourcesDownloadRefinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "S4dKDojap", name: "Child Subject Slug", value: properties.childSubjectSlug});
  eventPropertiesArray.push({id: "5QAyZtsHD", name: "Child Subject Name", value: properties.childSubjectName});
  eventPropertiesArray.push({id: "uWHOnx61K", name: "Learning Tier", value: properties.learningTier});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "cTKf4kbAHd211SR05Bbq8", "bef533414613a2378db22a0b152e401218e13229a10c0c4a38e927499473cf2e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Resources Download Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("cTKf4kbAHd211SR05Bbq8", "Curriculum Resources Download Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Resources Download Refined", eventProperties, "cTKf4kbAHd211SR05Bbq8", "bef533414613a2378db22a0b152e401218e13229a10c0c4a38e927499473cf2e");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Resources Download Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonMediaClipsStartedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  learningCycle: string | null | undefined;
  releaseGroup: string;
  phase: PhaseValueType | null | undefined;
  mediaClipsButtonName: MediaClipsButtonNameValueType;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Lesson Media Clips Started: A media clips button is pressed on the lesson overview page
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.learningCycle: media clips are grouped by learning cycles within a lesson
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.mediaClipsButtonName: The button the user selected to start media clips
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/YbxoviiZ7zqvdvU_8FRv9}
 */
export function lessonMediaClipsStarted(properties: LessonMediaClipsStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.learningCycle !== undefined && properties.learningCycle !== null ?
    eventPropertiesArray.push({id: "1VlnBdNXVpsZ1kfInJRHO", name: "Learning Cycle ", value: properties.learningCycle}) :
    eventPropertiesArray.push({id: "1VlnBdNXVpsZ1kfInJRHO", name: "Learning Cycle ", value: null});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  eventPropertiesArray.push({id: "BHWrIWv1_j8CL9nGB_oHk", name: "Media Clips Button Name", value: properties.mediaClipsButtonName});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "YbxoviiZ7zqvdvU_8FRv9", "f14cb4a0de9035f21b3a254828094ebff7f4ef29a4e27a8469f2002f51d2bcb2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Media Clips Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("YbxoviiZ7zqvdvU_8FRv9", "Lesson Media Clips Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Media Clips Started", eventProperties, "YbxoviiZ7zqvdvU_8FRv9", "f14cb4a0de9035f21b3a254828094ebff7f4ef29a4e27a8469f2002f51d2bcb2");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Media Clips Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MediaClipsPlaylistPlayedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  durationSeconds: number;
  isCaptioned: boolean;
  videoPlaybackId: string[];
  videoTitle: string;
  timeElapsedSeconds: number;
  isMuted: boolean;
  videoLocation: VideoLocationValueType | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType;
  mediaClipsCount: number;
  mediaClipIndex: number;
  learningCycle: string | null | undefined;
  releaseGroup: string;
  phase: PhaseValueType | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Media Clips Playlist Played: A user plays one of the media clips video or audios
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.durationSeconds: Video length in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.videoTitle: Title of video
 * @param properties.timeElapsedSeconds: Progress made through a video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.videoLocation: Where is the video on the site (eg. webinar, marketing, lesson, blog, etc)
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.mediaClipsCount: The number of media clips in a learning cycle group
 * @param properties.mediaClipIndex: The index of the media clip within a group of clips grouped by learning cycle
 * @param properties.learningCycle: media clips are grouped by learning cycles within a lesson
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/VvOi9lNYmXNrmqXMSkT-X}
 */
export function mediaClipsPlaylistPlayed(properties: MediaClipsPlaylistPlayedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: properties.durationSeconds});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "3a0mowzVyL", name: "Time Elapsed (Seconds)", value: properties.timeElapsedSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  properties.videoLocation !== undefined && properties.videoLocation !== null ?
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: properties.videoLocation}) :
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway});
  eventPropertiesArray.push({id: "TgO2h8F6IqCxcyo-lpYvs", name: "Media Clips Count", value: properties.mediaClipsCount});
  eventPropertiesArray.push({id: "ZygH-hGIazCYTEblKBWcB", name: "Media Clip Index", value: properties.mediaClipIndex});
  properties.learningCycle !== undefined && properties.learningCycle !== null ?
    eventPropertiesArray.push({id: "1VlnBdNXVpsZ1kfInJRHO", name: "Learning Cycle ", value: properties.learningCycle}) :
    eventPropertiesArray.push({id: "1VlnBdNXVpsZ1kfInJRHO", name: "Learning Cycle ", value: null});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "VvOi9lNYmXNrmqXMSkT-X", "0fc388c99ab6b509a6c1146680ca163fd7c631400540c4fd991dabc9d5d1bffe", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Media Clips Playlist Played", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("VvOi9lNYmXNrmqXMSkT-X", "Media Clips Playlist Played", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Media Clips Playlist Played", eventProperties, "VvOi9lNYmXNrmqXMSkT-X", "0fc388c99ab6b509a6c1146680ca163fd7c631400540c4fd991dabc9d5d1bffe");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Media Clips Playlist Played", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchFilterModifiedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  filterModificationType: FilterModificationTypeValueType;
  filterType: FilterTypeValueType;
  filterValue: string;
  searchTerm: string;
}
/**
 * Search Filter Modified: A search filter is added or removed using the filter buttons 
 * 
 * When to trigger this event:
 * 1. A search filter button is selected.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/JbWzId2dPo6mN6Y3aHwMr/trigger/Cx9_xD-MYDD1Tt00diuFC
 * 
 * @param properties the properties associatied with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA and Aila. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.

This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers

NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.filterModificationType: Describes whether a filter is being added to search ('add') or removed ('remove')
 * @param properties.filterType: Describes the dimension the filter is designed to control such as subject, key stage, or resource type
 * @param properties.filterValue: The value added to the filter (e.g. 'English' or 'AQA'). In the case where multiple filters are chosen simultaneously (e.g. Exam board and Tier) then both values should be sent separated by ', ' (e.g. 'AQA, Higher')
 * @param properties.searchTerm: The term entered by the user for the search.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/branches/4MiS4rkehbuVZbFeC26sf/events/JbWzId2dPo6mN6Y3aHwMr}
 */
export function searchFilterModified(properties: SearchFilterModifiedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "0M2Ix3r8aivly0Q1sFyLs", name: "Filter Modification Type", value: properties.filterModificationType});
  eventPropertiesArray.push({id: "XPABjlx_F", name: "Filter Type", value: properties.filterType});
  eventPropertiesArray.push({id: "v3Ne3qUXs", name: "Filter Value", value: properties.filterValue});
  eventPropertiesArray.push({id: "hHufJiP_N", name: "Search Term", value: properties.searchTerm});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "JbWzId2dPo6mN6Y3aHwMr", "052fc631cc3d6bdfc37b7dd0846c51029e41b535f28c60957e8a35b16399c87c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Filter Modified", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("JbWzId2dPo6mN6Y3aHwMr", "Search Filter Modified", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Filter Modified", eventProperties, "JbWzId2dPo6mN6Y3aHwMr", "052fc631cc3d6bdfc37b7dd0846c51029e41b535f28c60957e8a35b16399c87c");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Filter Modified", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  avoInspectorApiKey,
  SingleSignOnService,
  FilterModificationType,
  LessonReleaseCohort,
  EventVersion,
  ResourceTypes,
  VideoLocation,
  UserAccountVerificationStatus,
  ExamBoard,
  Context,
  ComponentType,
  MediaClipsButtonName,
  OnwardIntent,
  SchoolOption,
  AnalyticsUseCase,
  QuestionResult,
  DownloadResourceButtonName,
  ResourceType,
  TierName,
  Product,
  PageName,
  Platform,
  ContentGuidanceWarning,
  Phase,
  UserRoleType,
  PupilExperienceLessonActivity,
  FilterType,
  ShareMedium,
  SearchSource,
  Pathway,
  Audience,
  NavigatedFrom,
  KeyStageTitle,
  LearningTier,
  SearchResultType,
  EngagementIntent,
  planALessonSelected,
  newsletterSignUpCompleted,
  classroomSelected,
  teacherHubSelected,
  developYourCurriculumSelected,
  supportYourTeamSelected,
  notificationSelected,
  aboutSelected,
  videoStarted,
  videoPaused,
  videoPlayed,
  videoFinished,
  lessonResourcesDownloaded,
  keyStageSelected,
  subjectSelected,
  unitAccessed,
  lessonSelected,
  unitSequenceRefined,
  webinarPageViewed,
  helpCentreSelected,
  tierSelected,
  pageview,
  resourceContainerExpanded,
  curriculumMapDownloaded,
  lessonResourceDownloadStarted,
  searchAccessed,
  searchResultOpened,
  searchJourneyInitiated,
  curriculumVisualiserAccessed,
  programmeThreadHighlighted,
  unitOverviewAccessed,
  onwardContentSelected,
  lessonShared,
  lessonShareStarted,
  searchRefined,
  searchResultExpanded,
  lessonCompleted,
  lessonActivityCompleted,
  lessonActivityCompletedIntroduction,
  lessonActivityCompletedStarterQuiz,
  lessonActivityCompletedLessonVideo,
  lessonActivityCompletedExitQuiz,
  lessonActivityCompletedLessonAudio,
  lessonStarted,
  lessonActivityStarted,
  lessonActivityStartedIntroduction,
  lessonActivityStartedStarterQuiz,
  lessonActivityStartedLessonVideo,
  lessonActivityStartedExitQuiz,
  lessonActivityStartedLessonAudio,
  curriculumResourcesDownloaded,
  lessonActivityAbandoned,
  lessonActivityAbandonedStarterQuiz,
  lessonActivityAbandonedIntroduction,
  lessonActivityAbandonedLessonVideo,
  lessonActivityAbandonedExitQuiz,
  lessonActivityAbandonedLessonAudio,
  lessonAssistantAccessed,
  lessonAccessed,
  browseRefined,
  browseRefinedAccessed,
  lessonActivityDownloaded,
  lessonActivityDownloadedWorksheet,
  contentGuidanceAccepted,
  contentGuidanceDeclined,
  activityResultsShared,
  lessonSummaryReviewed,
  userSignUpCompleted,
  userOnboardingCompleted,
  userSignIn,
  userSignOut,
  userOnboardingProgressed,
  lessonAbandoned,
  browseAccessed,
  questionAttemptSubmitted,
  teacherShareInitiated,
  teacherShareActivated,
  teacherShareConverted,
  unitDownloadInitiated,
  teacherNoteDialogueOpened,
  teacherNoteSaved,
  curriculumVisualiserExited,
  curriculumVisualiserTabAccessed,
  unitOverviewExplored,
  productHomepageAccessed,
  curriculumLandingPageAccessed,
  curriculumExplainerExplored,
  curriculumResourcesDownloadRefined,
  lessonMediaClipsStarted,
  mediaClipsPlaylistPlayed,
  searchFilterModified,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["planALessonSelected","newsletterSignUpCompleted","classroomSelected","teacherHubSelected","developYourCurriculumSelected","supportYourTeamSelected","notificationSelected","aboutSelected","videoStarted","videoPaused","videoPlayed","videoFinished","lessonResourcesDownloaded","keyStageSelected","subjectSelected","unitAccessed","lessonSelected","unitSequenceRefined","webinarPageViewed","helpCentreSelected","tierSelected","pageview","resourceContainerExpanded","curriculumMapDownloaded","lessonResourceDownloadStarted","searchAccessed","searchResultOpened","searchJourneyInitiated","curriculumVisualiserAccessed","programmeThreadHighlighted","unitOverviewAccessed","onwardContentSelected","lessonShared","lessonShareStarted","searchRefined","searchResultExpanded","lessonCompleted","lessonActivityCompleted","lessonActivityCompletedIntroduction","lessonActivityCompletedStarterQuiz","lessonActivityCompletedLessonVideo","lessonActivityCompletedExitQuiz","lessonActivityCompletedLessonAudio","lessonStarted","lessonActivityStarted","lessonActivityStartedIntroduction","lessonActivityStartedStarterQuiz","lessonActivityStartedLessonVideo","lessonActivityStartedExitQuiz","lessonActivityStartedLessonAudio","curriculumResourcesDownloaded","lessonActivityAbandoned","lessonActivityAbandonedStarterQuiz","lessonActivityAbandonedIntroduction","lessonActivityAbandonedLessonVideo","lessonActivityAbandonedExitQuiz","lessonActivityAbandonedLessonAudio","lessonAssistantAccessed","lessonAccessed","browseRefined","browseRefinedAccessed","lessonActivityDownloaded","lessonActivityDownloadedWorksheet","contentGuidanceAccepted","contentGuidanceDeclined","activityResultsShared","lessonSummaryReviewed","userSignUpCompleted","userOnboardingCompleted","userSignIn","userSignOut","userOnboardingProgressed","lessonAbandoned","browseAccessed","questionAttemptSubmitted","teacherShareInitiated","teacherShareActivated","teacherShareConverted","unitDownloadInitiated","teacherNoteDialogueOpened","teacherNoteSaved","curriculumVisualiserExited","curriculumVisualiserTabAccessed","unitOverviewExplored","productHomepageAccessed","curriculumLandingPageAccessed","curriculumExplainerExplored","curriculumResourcesDownloadRefined","lessonMediaClipsStarted","mediaClipsPlaylistPlayed","searchFilterModified"]
